// ./fe-build.sh ffnmento

import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "./components/common.js";
import Pager from './components/common/pagingUser.vue';
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import swal from 'sweetalert';
import Alram from './components/common/alram.vue';
import VueFileAgent from 'vue-file-agent';
import Validator from './components/common/validation.js';
import validation from 'validator';
import Share from './components/common/share.js';
import KProgress from 'k-progress';
import StoryEditor from "./components/common/storyeditor.vue";
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent);

import Profile from './components/common/dragImgProfileOne.vue';
import DropImg from "./components/common/dragImgFile.vue";
import DropImgAlt from "./components/common/dragImgAlt.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import winwheel from './components/ynadmin/common/winwheel.vue';
import ProfileList from "./components/common/dragImgFile.vue";
Vue.component("dfile", ProfileList);


Vue.component("profile", Profile);
Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component("star-rating", VueStarRating.default);
Vue.component("editor", Editor);
// Vue.component('dropimg', DropImg);
Vue.component('dropimg', DropImgAlt);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('alarm', Alram);
Vue.component('winwheel', winwheel);
Vue.component('k-progress', KProgress);
Vue.component('storyeditor', StoryEditor);

Vue.prototype.$pager = Pager;

// 더보기 리스트 복원을 위한 상수
const CONTENT_LIST_NAV_FROM_DETAIL_KEY = 'CONTENT_LIST_BACK_INTENT';
const CONTENT_LIST_STATE_KEY = 'CONTENT_LIST_STATE';

new Vue({
  el: '#realinfo',
  data: function () {
    return {

      isDetailSearch: false,
      listimgfile: [],
      mainName: '알통정보',
      listBanner: [''],
      img: null,
      video: null,
      doc: null,
      rc: 1,
      rm: 1,
      ypk: '',
      isShare: false,
      isEvent: false,
      isReplyOn: false,
      isReReplyOn: false,
      replyModel: {
        replyList: [],
        rereplyList: [],
        replyName: '',
        userKey: '',
        modifyTarget: '',
        modifyContents: '',
        replyPassword: '',
        replyContents: '',
        replyStarCnt: '',
        reReplyTarget: '',
        reReplyContents: ''
      },
      detailOption: {},
      videoRes: {},
      commonParams: {},

      listWheel: [],
      wheelResult: "",


      inputstatus: '',
      inputstatus1: '',
      inputstatusArr: [],
      selectSubCatBoxInContentList: {code: "", value: ""},
      selectBrdCntList: {code: "", value: ""},
      listEmailCodes: [],
      selectedEmail: '',
      labelModel: {
        emailLabel: '직접입력'
      },
      selectDetailInf: {evt11: '', evt21: '', evt22: '', evt23: '', evt31: '', evt32: '', evt41: '', evt42: ''},
      selectDetailInfList: {
        evt11: [],
        evt21: [],
        evt22: [],
        evt23: [],
        evt31: [],
        evt32: [],
        evt41: [],
        evt42: [],
        evt51: [],
        evt52: []
      },

      showMore: true,
      viewModel: {
        showMore: true,
        zf:1,
        zt:1,
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 0,
          blockSize: 0,
          endSize: 0,
          list: [],
          // href: "#a",
          href: "javascript:void(0);",
          etc: '',
          callBack: function (n) {
            Common.fnLocationBarChangeQuery({pageNum: n === 1 ? null : n})
            window.scrollTo(0, 0); // 페이지 이동시 탑으로 이동
            let _etc = this.model.viewModel.pager.etc;
            if (_etc === 'fnGetContents') {
              this.model.fnGetContents(n);
            } else if (_etc === 'fnGetMentoGroupList') {
              this.model.fnGetMentoGroupList(n);
            } else if (_etc === 'fnGetMentoGroupMentoContents') {
              this.model.fnGetMentoGroupMentoContents(n);
            } else if (_etc === 'fnGetMainContents') {
              this.model.fnGetMainContents(n);
            } else if (_etc === 'fnGetYouthFacltList') {
              this.model.fnGetYouthFacltList(n);
            } else if (_etc === 'fnGetEventByMain') {
              this.model.fnGetEventByMain(n);
            } else if (_etc === 'fnGetEventBySub') {
              this.model.fnGetEventBySub(n);
            } else if (_etc === 'fnGetMentoContentList') {
              this.model.fnGetMentoContentList(n);
            } else if (_etc === 'fnGetPolicyByMain') {
              this.model.fnGetPolicyByMain(n);
            } else if (_etc === 'fnGetMynaviEventList') {
              this.model.fnGetMynaviEventList(n);
            } else if (_etc === 'fnGetMynaviOrganizationList') {
              this.model.fnGetMynaviOrganizationList(n);  /*  기관 알통정보 목록 */
            } else if (_etc === 'fnGetMyReplyList') {
              this.model.fnGetMyReplyList(n);
            }
          }
        }
      },
      selectProFiles: {
        detail: null,
        param: 'PROFILE',
        text: '변경할 이미지를 선택해주세요'
      },
      mainViewModel: {
        isMentoContents: true,
        isSpecFacil: false,
        isYouthPolicy: false,
        isEvent: false,
        isPress: false,
        hotContents: {
          title: ' '
        },
        allContents: [{tesxt: ' '}],
        recomContents: [{tesxt: ' '}],
        eventContents: [{tesxt: ' '}],
        pressContents: [{tesxt: ' '}],
        pressSearch: '',
        youthFacltVO: {
          isLike: false,
          fileImgList: []
        },
        youthFacltList: [{tesxt: ' '}],
        youthPolicyList: [{tesxt: ' '}],
        totalContentCnt: 0,
        totalFacilityCnt: 0,
        subCatCd: '',
        paramBrdDto : null
      },
      fpt: '',
      eventViewModel: {
        isFrst: true,
        isScnd: false
      },
      orderingList: {
        date: '1',
        hit: '2'
      },
      postingInitValues: {
        subGroup: '',
        tab: '1'
      },
      postingModel: {
        contentsList: {},
        categoryList: [],
        orderingCodeList: {},
        orderingCodeValue: '1',
        code: '',
        codeName: '',
        keyword: '',
        isLatest: true,
        isPopularity: false
      },
      mentoGroupModel: {
        mentoList: [{tesxt: ' '}],
        mentoContentsList: [{tesxt: ' '}],
        replyList: [{tesxt: ' '}],
        reportList: [{tesxt: ' '}],
        replyDepthZero: [{tesxt: ' '}],
        replyDepthOne: [{tesxt: ' '}],
        docList: [],
        imgList: [],
        vdList: [],
        mentoVO: {},
        postingVO: {},
        contentVO: {
          fileEtcList: [],
          fileImgList: [],
          fileVdList: []
        },
        eventVO: {},
        userKey: '',
        boardUid: '',
        reportValues: '',
        reportEtcValue: '',
        replyName: '',
        replyPassword: '',
        replyContents: '',
        replyUpdateContents: '',
        checkUidKey: '',
        inputPassword: '',
        isActionOption: 0,
        tab: 0,
        replyUidKey: 0,
        replyStarCnt: 0,
        replyCnt: 0,
        isIntro: false,
        isContents: false,
        isReplyOn: false,
        isReplyUpdateOn: false,
        isReReplyOn: false,
        isReReplyUpdateOn: false,
        isReportOn: false,
        isPassword: false,
        isButtonAction: true,
        isHideEventBtn: true // 이벤트 참여하기 버튼 감추기 여부
      },
      mynaviModel: {
        mentoVo: {
          userImage: '',
          nickName: '',
          mentoIntro: ''
        },
        contentList: [],
        eventList: [],
        contentListCnt: 0,
        envetListCnt: 0,
        keyword: '',
        startDate: '',
        endDate: '',
        insertDate: '',
        title: '',
        content: '',
        type: '',
        link: 'https://',
        today: new Date(),
        rowValue: '10건씩 보기',
        rowNum: 10,
        orderList: [],
        video: '',
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      },
      mynaviViewModel: {
        isToday: true,
        isWeek: false,
        isOneMonth: false,
        isTwoMonth: false,
        isSixMonth: false,
        isProfileUpdate: false
      },
      mynaviValidation: {
        isTitle: false,         //제목
        isContents: false,      //내용
        isCategory: false,      //카테고리
        isType: false,            //방식
        isInsertDate: false       //작성일
      },
      boundRating: 3,
      expInfoCodeList: [],
      lineCode2List: {}, // 계열 상세 코드

      // 진로체험활동 멘토 프로필정보
      expMentoModel: {
        uidKey: 0,
        nickName: '',
        gubun: '',
        info: '',
        career: '',
        intr: '',

        lineValues: [],        // 선택한 계열 목록
        lineDetailValues: [],  // 선택한 계열 상세 목록
        userImage: '',         // 프로필 이미지
        prev_ok_uidkey: 0,     // 기존 ok 였던 프로필의 uidKey

        reqStatus: '',
        cmm_view_yn: ''
      },
      expMentoLineMap: {}, // 진로체험활동 멘토 프로필의 계열 선택항목들
      gubunLabel: '',
      selectGubun: '',
      eventVoteItemList: [], // (투표 이벤트) 투표 항목 목록
      eventVoteResultList: [], // (투표 이벤트) 투표 결과
    }
  },
  mounted: function () {
    if(this.viewModel.zf != null) {
      setInterval(this.doRolling, 3000);
    }

    // 더보기 리스트 복원 로직 (contentList 페이지)
    const _path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
    const _isContentListPage = _path === '/customer/realinfo/content/list';

    if (_isContentListPage) {
      const urlParams = new URLSearchParams(window.location.search);
      const _fromDetail = sessionStorage.getItem(CONTENT_LIST_NAV_FROM_DETAIL_KEY) === '1';
      const hasRestoreFlag = urlParams.has('restore') && urlParams.get('restore') === '1';

      let _isBack = false;
      try {
        const nav = (performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation') : null;
        if (nav && nav.length && nav[0].type === 'back_forward') {
          _isBack = true;
        } else if (window.performance && window.performance.navigation) {
          _isBack = (window.performance.navigation.type === 2);
        }
      } catch (e) {}

      if (_fromDetail && (_isBack || hasRestoreFlag)) {
        this._contentListRestored = this.restoreContentListState();
        sessionStorage.removeItem(CONTENT_LIST_NAV_FROM_DETAIL_KEY);

        if (hasRestoreFlag) {
          urlParams.delete('restore');
          const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
          window.history.replaceState({}, '', newUrl);
        }
      }
    }

    try {
      let pageName = $('#pageName').val();
      if (pageName === 'contentDetail' || pageName === 'facilityDetail' || pageName === 'eventDetail') {
        Kakao.init("25727a9190252a67c490a909452aecd8");
      }
      this.fnOnPageLoad();
      // this.scrollToTop();

    } catch (e) {
      console.log(e);
    }
  },
  created: function () {
    let _data = this.$data.postingModel;
    let vm = this;
    let _keyList = Object.keys(_data);
    for (let values in _keyList) {
      let _values = _keyList[values];
      if (_values.indexOf("CodeList") > -1) {
        _data[_values] = Common.fnBrdOrderingCode();
      }
    }
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
  },
  updated: function () {
    let pageName = $('#pageName').val();
    if (pageName === 'realinfoMain') {
      $(".mainName").text("");
      $(".btn_back").hide();
    }
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  watch: {
    selectSubCatBoxInContentList: function (newValue, oldValue) {
      if (newValue !== "") {
        this.postingModel.codeName = newValue.value;
        this.postingModel.code = newValue.code;
      } else {
        this.postingModel.code = "";
        this.postingModel.codeName = "";
      }
      let pageName = $('#pageName').val();
      if (pageName === 'contentList') {
        this.fnGetContents(1);
      }
      if (pageName === 'mentoDetail') {
        this.fnGetMentoGroupMentoContents(1);
      }
    },
    selectBrdCntList: function (newValue, oldValue) {
      if (newValue !== "") {
        this.mynaviModel.rowValue = newValue.value;
        this.mynaviModel.rowNum = newValue.code;
      } else {
        this.mynaviModel.rowValue = "";
        this.mynaviModel.rowNum = "";
      }

      let pageName = $('#pageName').val();
      if (pageName === 'mynaviEventList') {
        this.fnGetMynaviEventList(1);
      } else if (pageName === 'mentoContentList') {

        this.fnGetMentoContentList(1);
      } else if (pageName === 'mentoParticipationList') {
        this.fnGetMyReplyList(1);
      } else if (pageName === 'mynaviOrganizationContentList') {
        this.fnGetMynaviOrganizationList(1);
      }
    },
    selectedEmail: function (val) {
      this.labelModel.emailLabel = (val === '') ? '직접입력' : val.cmm_sys_titl;
    }
  },
  methods: {

    clickFunc: function (event) {
      event.target.focus();// Add me
    },
    doRolling: function() {
      if (this.viewModel.zf < this.viewModel.zt) {
        this.ztb();
      } else {
        this.viewModel.zf = 1;
      }
    },
    fnOnPageLoad: function () {
      let pageName = $('#pageName').val();

      this.onLoadLoginUser();
      this.mainName = '알통정보'; // 이벤트 상세, 이벤트 목록이 아닌 경우는 '알통정보'
      let _tab = 0;
      if (pageName === 'contentDetail') {
        this.fnGetMentoGroupMentoContentsDetail(1);
        this.onClickEventReplyWrite()
      } else if (pageName === 'contentList') { // 알통정보 목록 vue init : xbw2IYVE3ztxhuWWt5xkJGBYv0o9ZN

        // 더보기 리스트 복원된 경우 API 호출 건너뛰기
        if (this._contentListRestored) {
          // 카테고리 목록만 로드 (복원된 상태를 유지하면서)
          this.fnGetContentCategoryOnly();
          return;
        }

        const select = $('#select').val();
        const order = Number($('#order').val()) || 1;
        const pageNum = Number($('#pageNum').val()) || 1;

        this.postingModel.code = select;
        this.postingModel.orderingCodeValue = order;
        if (order === 2) {
          this.postingModel.isLatest = true;
          this.postingModel.isPopularity = false;
        } else if (order === 1) {
          this.postingModel.isLatest = false;
          this.postingModel.isPopularity = true;
        }
        // select 는.. 목록 데이터를 api 에서 받아오기 때문에 api 받은 다음에 설정 한다.

        this.fnGetContents(pageNum);

      } else if (pageName === 'mentoDetail') {
        this.fnGetMentoGroupMentoIntro(1);
        let _tab = $('#tab').val();
        this.fnOnChangeTabByMentoGroup(_tab);

      } else if (pageName === 'mentoGroup') {
        this.fnGetMentoGroupList(1);

      } else if (pageName === 'eventDetail') {
        this.fnGetEventAnnounceContents();
        this.onClickEventReplyWrite()
        this.mainName = '알림마당'; // 이벤트 상세인 경우 메뉴 이동으로 '알림마당'

      } else if (pageName === 'eventList') {
        let _tab = $('#tab').val();
        if (_tab != null && _tab == '') {
          _tab = 1;
        }

        let pageNum = $('#pageNum').val();

        if (pageNum != null && pageNum !== "") {
          this.fnChgSubTabByEventBackspace(_tab, pageNum);
        } else {
          this.fnChgSubTabByEvent(_tab);
        }
        this.mainName = '알림마당'; // 진행중인 이벤트,이벤트 당첨발표인 경우 메뉴 이동으로 '알림마당'
      } else if (pageName === 'realinfoMain') {
        let _tab = $('#tab').val();

        let pageNum = $('#pageNum').val();

        if (pageNum != null && pageNum !== "") {

          let tabIdx = $('#tabIdx').val();
          this.fnOnChangeTabByMentoMainBackspace(tabIdx, pageNum);
        } else {
          this.fnOnChangeTabByMentoMain(_tab);
        }

        // this.fnOnChangeTabByMentoMain(_tab);

      } else if (pageName === 'facilityList') {
        let pageNum = $('#pageNum').val();

        if (pageNum != null && pageNum !== "") {
          this.fnGetYouthFacltList(pageNum);
        } else {
          this.fnGetYouthFacltList(1);
        }

      } else if (pageName === 'facilityDetail') {
        this.fnGetYouthFacltDetail();
      } else if (pageName === 'mentoProfile') {
        this.fnGetMentoProfile();
      } else if (pageName === 'mentoContentList') {
        this.mynaviModel.keyword = '';
        this.mynaviModel.startDate = '';
        this.mynaviModel.endDate = '';
        this.fnSetCntOption();
        //this.fnGetMentoContentListSessionStorage();
        this.fnGetMentoContentList(this.viewModel.pager.pageNo);
      } else if (pageName === 'mentoContentWrite') {
        this.fnGetContentCategory();
      } else if (pageName === 'mentoContentUpdate') {
        this.fnGetContentCategory();
        let _uidKey = $('#uidKey').val();
        this.fnGetMentoContent(_uidKey);
      } else if (pageName === 'mynaviEventList') {
        this.mainName = '이벤트 관리';
        this.fnSetCntOption();
        this.fnGetMynaviEventList(1);
      } else if (pageName === 'mentoParticipationList') {
        this.mynaviModel.keyword = '';
        this.mynaviModel.startDate = '';
        this.mynaviModel.endDate = '';
        this.fnSetCntOption();
        this.fnGetMentoPrtListSessionStorage();
        this.fnGetMyReplyList(this.viewModel.pager.pageNo);
      } else if (pageName === 'mynaviOrganizationContentList') {
        this.mynaviModel.keyword = '';
        var now = new Date();
        var threeMthAgo = new Date(now.setMonth(now.getMonth()-3));

        this.mynaviModel.startDate = threeMthAgo;
        this.mynaviModel.endDate = new Date();
        this.fnSetCntOption();
        this.fnGetMynaviOrganizationList(1);
      } else if (pageName === 'centerContentUpdate') {
        let _uidKey = $('#uidKey').val();
        this.fnGetCenterContent(_uidKey);
      } else if (pageName === 'expInfoMentoProfile') {
        this.mainName = '내비샘';
        this.fnGetExpMentoProfile(); // 내비쌤 프로필 조회
        this.fnOnPostCode('AFLNVADMNV000000'); // 계열 목록 가져오기

      }
    },
    // mentoParticipateList 페이지 히스토리 백
    fnSetMentoPrtListSessionStorage() {

      let vm = this;
      let backData = [{
        pageNo: vm.viewModel.pager.pageNo,
        startDate: vm.mynaviModel.startDate,
        endDate: vm.mynaviModel.endDate,
        isDetailSearch: vm.isDetailSearch,
        keyword: vm.mynaviModel.keyword,
      }]
      sessionStorage.setItem('mentoPrt.list', JSON.stringify(backData));
    },
    fnGetMentoPrtListSessionStorage() {
      let vm = this;
      let backData;
      if (sessionStorage.getItem('mentoPrt.list') != null) {
        backData = JSON.parse(sessionStorage.getItem('mentoPrt.list'));
        sessionStorage.removeItem('mentoPrt.list');

        vm.viewModel.pager.pageNo = backData[0].pageNo;
        vm.isDetailSearch = backData[0].isDetailSearch;
        vm.mynaviModel.startDate = backData[0].startDate;
        vm.mynaviModel.endDate = backData[0].endDate;
        vm.mynaviModel.keyword = backData[0].keyword;
      }
      if (vm.isDetailSearch) {
        $('.search_detail').addClass("on");
      } else {
        $('.search_detail').removeClass("on");
      }
    },

    // mentoContentList 페이지 히스토리 백
    fnSetMentoContentListSessionStorage() {

      let vm = this;
      let backData = [{
        pageNo: vm.viewModel.pager.pageNo,
        startDate: vm.mynaviModel.startDate,
        endDate: vm.mynaviModel.endDate,
        isDetailSearch: vm.isDetailSearch,
        keyword: vm.mynaviModel.keyword,
      }]
      sessionStorage.setItem('mentoContent.list', JSON.stringify(backData));
    },
    fnGetMentoContentListSessionStorage() {
      let vm = this;
      let backData;
      if (sessionStorage.getItem('mentoContent.list') != null) {
        backData = JSON.parse(sessionStorage.getItem('mentoContent.list'));
        sessionStorage.removeItem('mentoContent.list');

        vm.viewModel.pager.pageNo = backData[0].pageNo;
        vm.isDetailSearch = backData[0].isDetailSearch;
        vm.mynaviModel.startDate = backData[0].startDate;
        vm.mynaviModel.endDate = backData[0].endDate;
        vm.mynaviModel.keyword = backData[0].keyword;
      }
      if (vm.isDetailSearch) {
        $('.search_detail').addClass("on");
      } else {
        $('.search_detail').removeClass("on");
      }
    },

    onClickIsDetailSearch() {
      let vm = this;
      vm.isDetailSearch = !vm.isDetailSearch;
      console.log(vm.isDetailSearch)
    },

    //보여주기 옵션 설정
    fnSetCntOption: function () {
      this.mynaviModel.orderList.push({
        code: "10",
        value: "10건씩 보기"
      });
      this.mynaviModel.orderList.push({
        code: "20",
        value: "20건씩 보기"
      });
      this.mynaviModel.orderList.push({
        code: "30",
        value: "30건씩 보기"
      });
    },
    onLoadLoginUser() {
      let param = {};
      let vm = this;
      Axios.post("/api/user/init/check", param).then(function (response) {
        vm.commonParams = response.data.commonParams;
        vm.replyModel.replyName = vm.commonParams.loginUserNickName;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //메인페이지 탭 스위치
    fnOnChangeTabByMentoMain(value) {
      if (value == 1) {
        this.mainViewModel.isMentoContents = true;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 2) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = true;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 3) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = true;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 4) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = true;
        this.mainViewModel.isPress = false;
      } else if (value == 5) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = true;
      }
      this.mainViewModel.pressSearch = '';
      this.fnGetMainContents(1);
    },
    //메인페이지 탭 스위치 (히스토리백 때문에 나눔)
    fnOnChangeTabByMentoMainBackspace(value, pageNum) {
      if (value == 1) {
        this.mainViewModel.isMentoContents = true;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 2) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = true;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 3) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = true;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = false;
      } else if (value == 4) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = true;
        this.mainViewModel.isPress = false;
      } else if (value == 5) {
        this.mainViewModel.isMentoContents = false;
        this.mainViewModel.isSpecFacil = false;
        this.mainViewModel.isYouthPolicy = false;
        this.mainViewModel.isEvent = false;
        this.mainViewModel.isPress = true;
      }
      this.mainViewModel.pressSearch = '';
      this.fnGetMainContents(pageNum);
    },
    //멘토상세페이지 탭 스위치
    fnOnChangeTabByMentoGroup(value) {
      if (value == 1) {
        this.fnGetMentoGroupMentoIntro();
        this.mentoGroupModel.isIntro = true;
        this.mentoGroupModel.isContents = false;
      } else if (value == 2) {
        this.fnGetMentoGroupMentoContents(1);
        this.mentoGroupModel.isIntro = false;
        this.mentoGroupModel.isContents = true;
      }
    },
    fnSetStartDate: function (e) {
      this.searchModel.startDate = e;
    },
    fnSetEndDate: function (e) {
      this.searchModel.endDate = e;
    },
    fnSetSubStartDate: function (e) {
      this.searchModel.subStartDate = e;
    },
    fnSetSubEndDate: function (e) {
      this.searchModel.subEndDate = e;
    },
    fnOnChangeMentoDetail: function () {
      this.fnGetMentoGroupDetailContents();
    },
    fnOnChangeMentoContents: function () {
      this.fnGetMentoGroupContentsList();
    },
    //메인페이지 콘텐츠 조회
    fnGetMainContents: function (pageNumber) {
      let vm = this;
      if (vm.mainViewModel.isMentoContents) {
        vm.fnGetContentsByMain(pageNumber);
        vm.fnGetContentsRecom(1);
        vm.fnGetExpInfoReportBanner();
      } else if (vm.mainViewModel.isSpecFacil) {
        vm.fnGetFacilitiesByMain(pageNumber);
      } else if (vm.mainViewModel.isYouthPolicy) {
        vm.fnGetPolicyByMain(pageNumber);
      } else if (vm.mainViewModel.isEvent) {
        vm.fnGetEventByMain(pageNumber);
      } else if (vm.mainViewModel.isPress) {
        vm.fnGetPressByMain(pageNumber);
      }
    },
    //메인페이지 콘텐츠 조회
    fnGetContentsByMain: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 8;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      if (pageNumber == 1) {
        vm.mainViewModel.allContents = []
      }
      let _param = {
        subGroup: vm.postingInitValues.subGroup,
        tab: Number(vm.postingInitValues.tab),
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
      }
      Axios.post("/api/realinfo/main/contents", param).then(function (response) {
        vm.mainViewModel.hotContents = response.data.paramBrdDtoList;
        vm.mainViewModel.paramBrdDto = response.data.paramBrdDto;
        // if(vm.mainViewModel.hotContents.prvsDat === 'Y'){
        //     vm.mainViewModel.hotContents.presentativeImg = vm.mainViewModel.hotContents.prvsImg;
        // }

        vm.mainViewModel.allContents = vm.mainViewModel.allContents.concat(response.data.paramBrdDtoList);
        vm.rm = Math.min(5, Math.floor(vm.mainViewModel.allContents.length/4))

        // vm.mainViewModel.allContents.forEach(function(item){
        //     if(item.prvsDat === 'Y'){
        //         item.presentativeImg = item.prvsImg;
        //     }
        // });
        if(response.data.paramBrdDtoListCnt == vm.mainViewModel.allContents.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMainContents');

      }).catch(function (ex) {
        console.log(ex);
      });
    },zta: function () {
      let vm = this;
      vm.viewModel.zf--
      if (vm.viewModel.zf < 1) vm.viewModel.zf = 1
    },
    ztb: function () {
      let vm = this;
      vm.viewModel.zf++
      if (vm.viewModel.zf > vm.viewModel.zt) vm.viewModel.zf = vm.viewModel.zt
    },
    fnGetExpInfoReportBanner: function() {
      const vm = this;
      let _param = {
        uidKey: 'BANNVLOCNV00900'
        , divide:'custommer'
      }
      let param = {
        pageNo : 0,
        pageSize : 10,
        paramText : JSON.stringify(_param)
      };

      Axios.post("/api/admin/banner/list", param).then(function(response) {
        vm.listBanner =  response.data.list;
        console.log('exp ListBanner', vm.listBanner);
      }).catch(function(ex) {
        console.log(ex);
      });
    },
    fnGetContentsRecom: function (pageNumber) {
      let vm = this;
      if (pageNumber == 1) {
        vm.mainViewModel.recomContents = []
      }
      let _param = {
        subGroup: vm.postingInitValues.subGroup,
        tab: Number(3),
      }
      let param = {
        param: _param,
        pageNo: 1,
        pageSize: 4,
      }
      Axios.post("/api/realinfo/main/contents", param).then(function (response) {
        vm.mainViewModel.recomContents = response.data.paramBrdDtoList;
        vm.mainViewModel.paramBrdDto = response.data.paramBrdDto;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    tab: function(t) {
      let vm = this;
      vm.postingInitValues.tab = t;
      vm.fnGetContentsByMain(1)
    },
    //메인페이지 청소년기관스페셜 목록 조회
    fnGetFacilitiesByMain: function (pageNumber) {
      let vm = this;
      if(pageNumber == 1) {
        vm.mainViewModel.youthFacltList = [];
        vm.mainViewModel.youthFacltVO  =[];
      }
      vm.viewModel.pager.rowSize = 4;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {};
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        param: _param
      };
      Axios.post("/api/realinfo/main/facilities", param).then(function (response) {
        vm.mainViewModel.youthFacltVO = vm.mainViewModel.youthFacltVO.concat(response.data.paramBrdDto);
        vm.mainViewModel.youthFacltList = vm.mainViewModel.youthFacltList.concat(response.data.paramBrdDtoList);
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMainContents');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetPolicyByMain: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 10; // 한 페이지당 보여줄 게시글 수
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = Number(pageNumber);

      if (vm.viewModel.pager.pageNo == 1) {
        vm.mainViewModel.youthPolicyList = []
      }
      let _param = {
        keyword: vm.ypk
      };
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        param: _param
      };
      Axios.post("/api/realinfo/youthpolicy/list", param).then(function (response) {
        vm.mainViewModel.youthPolicyList = vm.mainViewModel.youthPolicyList.concat(response.data.paramBrdDtoList);
        if(response.data.paramBrdDtoListCnt == vm.mainViewModel.youthPolicyList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
        console.log(response.data);
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetPolicyByMain');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //메인페이지 이벤트 조회
    fnGetEventByMain: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 6;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      };
      Axios.post("/api/realinfo/main/event/list", param).then(function (response) {
        vm.mainViewModel.eventContents = response.data.paramBrdDtoList;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetEventByMain');
      }).catch(function (ex) {
        console.log(ex);
      });

    },
    // 이벤트 더보기 조회
    fnGetEventBySub: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 6;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      if (vm.mainViewModel.subCatCd === '') {
        vm.mainViewModel.subCatCd = 'BRDNVYTHNV00210';
      }

      let _param = {
        subGroup: vm.mainViewModel.subCatCd,
        keyword: vm.mainViewModel.pressSearch
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      Axios.post("/api/realinfo/more/event/list", param).then(function (response) {
        vm.mainViewModel.eventContents = response.data.paramBrdDtoList;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetEventBySub');
      }).catch(function (ex) {
        console.log(ex);
      });

    },
    //메인페이지 보도자료 조회
    fnGetPressByMain: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 6;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {keyword: vm.mainViewModel.pressSearch}
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      Axios.post("/api/realinfo/main/press", param).then(function (response) {
        vm.mainViewModel.pressContents = response.data.paramBrdDtoList;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMainContents');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    // 카테고리 목록만 조회 (복원 시 사용)
    fnGetContentCategoryOnly: function () {
      let vm = this;
      let _param = {
        tab: vm.postingModel.orderingCodeValue,
        subGroup: vm.postingModel.code,
        keyword: vm.postingModel.keyword
      }
      let param = {
        param: _param,
        pageNo: 1,
        pageSize: 1
      }
      Axios.post("/api/realinfo/group/contents", param).then(function (response) {
        response.data.paramCdDtoList.forEach(function (item) {
          let val = {code: item.code, value: item.codeName}
          vm.postingModel.categoryList.push(val);
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //전문가콘텐츠 전체 리스트 조회
    fnGetContents: function (pageNumber) {
      // console.log(`전문가콘텐츠 전체 리스트 조회`)
      let vm = this;
      if(pageNumber == 1) {
        vm.mentoGroupModel.mentoContentsList = [];
      }
      vm.viewModel.pager.rowSize = 8;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      vm.postingModel.categoryList = [];
      let _param = {
        tab: vm.postingModel.orderingCodeValue,
        subGroup: vm.postingModel.code,
        keyword: vm.postingModel.keyword
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }

      // 알통정보 목록 api call  : xbw2IYVE3ztxhuWWt5xkJGBYv0o9ZN

      // Common.fnLocationBarChangeQueryDefault({
      //   select: vm.postingModel.code,       // 카테고리 선택값
      //   order: _param.tab,                  // 정렬 조건 : 인기순, 최신순
      //   pageNum: vm.viewModel.pager.pageNo  // 페이지 번호
      // }, {
      //   select: '',
      //   order: 1,
      //   pageNum: 1,
      // })

      Axios.post("/api/realinfo/group/contents", param).then(function (response) {
        vm.mentoGroupModel.mentoContentsList = vm.mentoGroupModel.mentoContentsList.concat(response.data.paramBrdDtoList);
        vm.rm = Math.min(5, Math.floor(vm.mentoGroupModel.mentoContentsList.length/4))
        response.data.paramCdDtoList.forEach(function (item) {
          let val = {code: item.code, value: item.codeName}
          vm.postingModel.categoryList.push(val);
        });

        // -- 카테고리 선택값 반영
        // Reload 또는 back 으로 돌아온 경우 카테고리 선택값은 있으니
        // 카테고리 목록이 늦게 로딩되는 구조이기 때문에 카테고리 목록 로딩 후
        // 카테고리 선택 값이 있을경우 이곳에서 늦게나마 선택해 준다.
        let content = vm.postingModel.categoryList.find(item => item.code == vm.postingModel.code);
        if (content != null) {
          vm.postingModel.codeName = content.value;
          vm.postingModel.code = content.code;
        }
        if(response.data.paramBrdDtoListCnt == vm.mentoGroupModel.mentoContentsList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
                // vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetContents');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //전문가콘텐츠 전체 리스트 조회 (백스페이스)
    fnGetContentsBackspace: function (pageNumber) {
      // console.log(`전문가콘텐츠 전체 리스트 조회 (백스페이스)`)
      let vm = this;
      vm.viewModel.pager.rowSize = 10;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      vm.postingModel.categoryList = [];
      let _param = {
        tab: vm.postingModel.orderingCodeValue,
        subGroup: vm.postingModel.code
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      Axios.post("/api/realinfo/group/contents", param).then(function (response) {
        vm.mentoGroupModel.mentoContentsList = response.data.paramBrdDtoList;
        response.data.paramCdDtoList.forEach(function (item) {
          let val = {code: item.code, value: item.codeName}
          vm.postingModel.categoryList.push(val);
        });

        let content = vm.postingModel.categoryList.find(item => item.code == vm.postingModel.code);

        if (content != null) {
          vm.postingModel.codeName = content.value;
          vm.postingModel.code = content.code;
        }

        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetContents');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //정렬순서 바꾸기
    fnChgOrdering: function (num) {
      let vm = this;
      vm.postingModel.orderingCodeValue = num;
      if (num == 1) {
        vm.postingModel.isLatest = true;
        vm.postingModel.isPopularity = false;
      } else {
        vm.postingModel.isLatest = false;
        vm.postingModel.isPopularity = true;
      }
      this.fnGetContents(1);
    },
    //청소년기관스페셜 리스트 조회
    fnGetYouthFacltList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 4;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {};
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        param: _param
      };
      Axios.post("/api/realinfo/facility/list", param).then(function (response) {
        vm.mainViewModel.youthFacltVO = response.data.paramBrdDto;
        vm.mainViewModel.youthFacltList = response.data.paramBrdDtoList;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetYouthFacltList');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //청소년기관스페셜 상세 페이지 조회
    fnGetYouthFacltDetail: function () {
      let vm = this;
      let _uidKey = $("#uidKey").val();
      let _tab = $("#tab").val();
      let _param = {
        uidKey: _uidKey,
        tab: _tab
      };
      let param = {param: _param};
      Axios.post("/api/realinfo/facility/detail", param).then(function (response) {
        vm.mainViewModel.youthFacltVO = response.data.paramBrdDto;
        document.title = response.data.paramBrdDto.title;
        vm.mainViewModel.youthFacltVO.fileImgList = response.data.fileImgList;
        vm.mainViewModel.youthFacltVO.fileVdList = response.data.fileVdList;
        if (vm.mainViewModel.youthFacltVO.likeYn === 'Y') {
          vm.mainViewModel.youthFacltVO.isLike = true;
        } else {
          vm.mainViewModel.youthFacltVO.isLike = false;
        }
        if (vm.mainViewModel.youthFacltVO.fileImgList.length > 0) {
          vm.mainViewModel.youthFacltVO.fileImgList.forEach(function (file) {
            file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mainViewModel.youthFacltVO.fileVdList.length > 0) {
          vm.mainViewModel.youthFacltVO.fileVdList.forEach(function (file) {
            file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //멘토단 리스트 조회
    fnGetMentoGroupList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 8;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {};
      let param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        param: _param
      };
      Axios.post("/api/realinfo/group/list", param).then(function (response) {
        vm.mentoGroupModel.mentoList = response.data.mentoGroupList;
        vm.fnSetPager(response.data.totalCount, 'fnGetMentoGroupList');
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //멘토 소개페이지 조회
    fnGetMentoGroupMentoIntro: function () {
      let vm = this;
      let _userKey = $("#userKey").val();
      let _param = {userKey: _userKey};
      let param = {param: _param};
      Axios.post("/api/realinfo/group/mentoIntro", param).then(function (response) {
        // vm.postingModel.contentsList = response.data.mentoPostingList;
        vm.mentoGroupModel.mentoVO = response.data.mentoVO;
        vm.mentoGroupModel.mentoVO.mentoIntro = vm.mentoGroupModel.mentoVO.mentoIntro.replace("\n", "<br/>");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //멘토 콘텐츠 리스트 조회
    fnGetMentoGroupMentoContents: function (pageNumber) {
      console.log(`멘토 콘텐츠 리스트 조회`)
      let vm = this;
      vm.viewModel.pager.rowSize = 5;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      vm.postingModel.categoryList = [];
      let _userKey = $("#userKey").val();
      let _param = {
        userKey: _userKey,
        tab: vm.postingInitValues.tab,
        subGroup: vm.postingModel.code
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      Axios.post("/api/realinfo/group/contents", param).then(function (response) {
        vm.mentoGroupModel.mentoContentsList = response.data.paramBrdDtoList;
        response.data.paramCdDtoList.forEach(function (item) {
          let val = {code: item.code, value: item.codeName}
          vm.postingModel.categoryList.push(val);
        });
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMentoGroupMentoContents');
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //멘토 콘텐츠 상세 페이지 조회
    fnGetMentoGroupMentoContentsDetail: function () {
      let vm = this;
      let _uidKey = $("#uidKey").val();
      let _userKey = $("#loginUserKey").val();
      let _param = {
        uidKey: _uidKey,
        userKey: _userKey
      };
      let param = {param: _param};
      Axios.post("/api/realinfo/group/contents/detail", param).then(function (response) {
        console.log(response);
        vm.mentoGroupModel.contentVO = response.data.paramBrdDto;
        vm.mentoGroupModel.contentVO.fileEtcList = response.data.fileEtcList;
        vm.mentoGroupModel.contentVO.fileImgList = response.data.fileImgList;
        vm.mentoGroupModel.contentVO.fileVdList = response.data.fileVdList;
        console.log(vm.mentoGroupModel.contentVO.fileVdList);
        if (vm.mentoGroupModel.contentVO.fileEtcList.length > 0) {
          vm.mentoGroupModel.contentVO.fileEtcList.forEach(function (file) {
            file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mentoGroupModel.contentVO.fileImgList.length > 0) {
          vm.mentoGroupModel.contentVO.fileImgList.forEach(function (file) {
            file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mentoGroupModel.contentVO.fileVdList.length > 0) {
          vm.mentoGroupModel.contentVO.fileVdList.forEach(function (file) {
            file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
          });
        }

        if (vm.mentoGroupModel.contentVO.likeYn === 'Y') {
          vm.mentoGroupModel.contentVO.isLike = true;
        } else {
          vm.mentoGroupModel.contentVO.isLike = false;
        }

        vm.mentoGroupModel.replyDepthZero = response.data.depthZeroList;
        vm.mentoGroupModel.replyDepthOne = response.data.depthOneList;
        vm.mentoGroupModel.replyCnt = vm.mentoGroupModel.replyDepthZero.length + vm.mentoGroupModel.replyDepthOne.length;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //신고 사유 조회
    fnGetReportContents: function () {
      let vm = this;
      let param = {};
      Axios.post("/api/realinfo/report/contents", param).then(function (response) {
        vm.mentoGroupModel.reportList = response.data.paramCdDtoList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //전체콘텐츠 더보기 클릭 이벤트
    onclickMoreContentList() {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName === 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.mainViewModel.isMentoContents) {
          tabIdx = 1;
        } else if (vm.mainViewModel.isSpecFacil) {
          tabIdx = 2;
        } else if (vm.mainViewModel.isYouthPolicy) {
          tabIdx = 3;
        } else if (vm.mainViewModel.isEvent) {
          tabIdx = 4;
        } else if (vm.mainViewModel.isPress) {
          tabIdx = 5;
        }

        sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      }

      location.href = "/customer/realinfo/content/list";
    },
    //멘토단 리스트 클릭 이벤트
    onClickMentoGroupList() {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName === 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.mainViewModel.isMentoContents) {
          tabIdx = 1;
        } else if (vm.mainViewModel.isSpecFacil) {
          tabIdx = 2;
        } else if (vm.mainViewModel.isYouthPolicy) {
          tabIdx = 3;
        } else if (vm.mainViewModel.isEvent) {
          tabIdx = 4;
        } else if (vm.mainViewModel.isPress) {
          tabIdx = 5;
        }

        sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      }

      location.href = "/customer/realinfo/mento";
    },
    //청소년 기관 스페셜 더보기 클릭 이벤트
    onClickMentoFacilityList() {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName === 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.mainViewModel.isMentoContents) {
          tabIdx = 1;
        } else if (vm.mainViewModel.isSpecFacil) {
          tabIdx = 2;
        } else if (vm.mainViewModel.isYouthPolicy) {
          tabIdx = 3;
        } else if (vm.mainViewModel.isEvent) {
          tabIdx = 4;
        } else if (vm.mainViewModel.isPress) {
          tabIdx = 5;
        }

        sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      }

      location.href = "/customer/realinfo/facility/list";
    },
    //청소년 기관 스페셜 상세 페이지
    onClickMentoFacilityDetail(uidKey, tab) {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName === 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.mainViewModel.isMentoContents) {
          tabIdx = 1;
        } else if (vm.mainViewModel.isSpecFacil) {
          tabIdx = 2;
        } else if (vm.mainViewModel.isYouthPolicy) {
          tabIdx = 3;
        } else if (vm.mainViewModel.isEvent) {
          tabIdx = 4;
        } else if (vm.mainViewModel.isPress) {
          tabIdx = 5;
        }

        sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      } else if (pageName === 'facilityList') {
        let pageNum = vm.viewModel.pager.pageNo;

        sessionStorage.setItem("URL", "/customer/realinfo/facility/list?pageNum=" + pageNum);
      }

      if (tab != null && tab != '') {
        location.href = "/customer/realinfo/facility/detail?uidKey=" + uidKey + "&tab=" + tab;
      } else {
        location.href = "/customer/realinfo/facility/detail?uidKey=" + uidKey;
      }

    },
    onClickMentoContentsList: function (userKey, tab) {
      location.href = "/customer/realinfo/mento/detail?userKey=" + userKey + "&tab=" + tab;
    },
    OnClickMentoDetailPage(uidKey) {
      let vm = this;
      let pageName = $('#pageName').val();

      if (pageName === 'realinfoMain') {
        let pageNum = vm.viewModel.pager.pageNo;
        let tabIdx = 1;

        if (vm.mainViewModel.isMentoContents) {
          tabIdx = 1;
        } else if (vm.mainViewModel.isSpecFacil) {
          tabIdx = 2;
        } else if (vm.mainViewModel.isYouthPolicy) {
          tabIdx = 3;
        } else if (vm.mainViewModel.isEvent) {
          tabIdx = 4;
        } else if (vm.mainViewModel.isPress) {
          tabIdx = 5;
        }

        sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      } else if (pageName === 'contentList') {
        // 더보기 리스트 복원을 위한 상태 저장
        this.saveContentListState();
        try { sessionStorage.setItem(CONTENT_LIST_NAV_FROM_DETAIL_KEY, '1'); } catch (e) {}
      } else if (pageName === 'mentoContentList') {
        this.fnSetMentoContentListSessionStorage()
      } else if (pageName === 'mentoParticipationList') {
        this.fnSetMentoPrtListSessionStorage()
      }

      location.href = "/customer/realinfo/content/detail?uidKey=" + uidKey;
    },
    //댓글 쓰기 이벤트
    OnClickMentoContentsReplyWrite: function () {
      let vm = this;
      vm.mentoGroupModel.isReplyOn = true;
    },
    //대댓글 쓰기 이벤트
    OnClickMentoContentsReReplyWrite: function (uidKey) {
      let vm = this;
      vm.mentoGroupModel.replyUidKey = uidKey;
      vm.mentoGroupModel.isReReplyOn = true;
    },
    //신고 팝업 열기
    OnClickMentoContentsReportOpen: function () {
      let vm = this;
      let _uidKey = $("#uidKey").val();
      let _userKey = $("#loginUserKey").val();
      let uri = "";
      if (this.fnIsEmptyChk(_userKey)) {
        swal({
          text : "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      } else {
        let _param = {uidKey: _uidKey,
        searchType: 'RCMNVYTHNV00200'};
        let param = {param: _param};
        Axios.post("/api/realinfo/report/history", param).then(function (response) {
          let result = response.data.result;
          if (result >= 1) {

            swal("접수된 신고 이력이 있습니다.");
            return false;
          } else {
            vm.fnGetReportContents();
            vm.mentoGroupModel.isReportOn = true;
          }
        }).catch(function (ex) {
          console.log(ex);
          return false;
        });
      }
    },
    //신고 팝업 닫기
    OnClickMentoContentsReportClose: function () {
      let vm = this;
      vm.mentoGroupModel.isReportOn = false;
      vm.mentoGroupModel.reportEtcValue = '';
      vm.mentoGroupModel.reportValues = '';
    },
    //댓글 내용 제출 이벤트
    onClickMentoContentsReplySubmit: function (_depth, _parentsUidKey) {
      let vm = this;
      let _name = vm.mentoGroupModel.replyName;
      let _password = vm.mentoGroupModel.replyPassword;
      let _contents = _depth == 0? vm.mentoGroupModel.replyContents.trim():vm.mentoGroupModel.reReplyContents.trim();
      let brdUidKey = $("#uidKey").val();
      let _userKey = $("#loginUserKey").val();

      //유효성 체크
      let _IsName = false;
      let _IsPw = false;
      if (_userKey == null || _userKey === '') {
        _IsName = validation.isEmpty(_name);
        _IsPw = validation.isEmpty(_password);
      }
      let _IsContent = validation.isEmpty(_contents);

      let _param = {
        brdUidKey: brdUidKey,
        vote: vm.mentoGroupModel.replyStarCnt,
        parentsUidKey: _parentsUidKey,
        depth: _depth,
        content: _contents,
        guestName: _name,
        guestPassword: _password
      };
      let param = {param: _param};
      if(_contents == "") {
        swal("댓글 내용을 작성해주세요");
        return;
      }
      else {
        swal({
          text : "댓글을 작성하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if (result) {
            Axios.post("/api/realinfo/group/contents/reply/write", param).then(function (response) {
              let resultCnt = response.data.result;
              if (resultCnt > 0) {
                vm.onClickMentoCountetnsReplyCancle();
                vm.mentoGroupModel.replyContents = '';
                vm.mentoGroupModel.reReplyContents = '';
              } else if (resultCnt == -999) {
                swal({
                  title: '등록 실패',
                  text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                  // icon: vm.fnOnLoadSwalImageData('error'),
                  buttons: {
                    confirm: {
                      value: true,
                      text: "확인",
                      visible: true,
                    },
                  },
                  dangerMode: false
                }).then(result => {
                  if (result) {
                    return false;
                  }
                });
              }
            }).catch(function (ex) {

              swal({
                title: '등록 실패',
                text: '게시물 등록이 실패하였습니다.',
                // icon: this.fnOnLoadSwalImageData('error'),
                buttons: true,
                dangerMode: false,
              }).then(result => {
                if (result) {
                  swal({
                    title: "",
                    text: "확인을 부탁드립니다.",
                    // icon: this.fnOnLoadSwalImageData('error'),
                  })
                  return false;
                }
              });
            });
          }
        });

      }
    },
    //댓글 수정/삭제 비밀번호 체크 이벤트
    onClickPasswordCheck: function (key, option) {
      let vm = this;
      if (vm.mentoGroupModel.checkUidKey == key) {
        vm.mentoGroupModel.isPassword = !vm.mentoGroupModel.isPassword;
      } else {
        vm.mentoGroupModel.isActionOption = option;
        vm.mentoGroupModel.checkUidKey = key;
        vm.mentoGroupModel.isPassword = true;
      }
    },
    //로그인 후 본인 댓글인 경우 이벤트
    onClickPasswordPass: function (option, replyVO) {
      this.fpt = '';
      if (option == 1) {
        if (replyVO.depth == 0) {
          this.onClickMentoContentsReplyUpdate(replyVO);
        } else {
          this.onClickMentoContentsReReplyUpdate(replyVO);
        }
      } else if (option == 2) {
        this.onClickMentoContentsReplyDeleteSubmit(replyVO.uidKey, replyVO.depth);
      }
    },
    //댓글 비밀번호 체크
    onClickReplyPwChk: function (replyVO) {
      let vm = this;
      if (vm.mentoGroupModel.inputPassword == replyVO.guestPassword) {
        vm.mentoGroupModel.isPassword = false;
        vm.mentoGroupModel.inputPassword = '';
        if (vm.mentoGroupModel.isActionOption == 1) {
          if (replyVO.depth == 0) {
            this.onClickMentoContentsReplyUpdate(replyVO);
          } else {
            this.onClickMentoContentsReReplyUpdate(replyVO);
          }
        } else if (vm.mentoGroupModel.isActionOption == 2) {
          this.onClickMentoContentsReplyDeleteSubmit(replyVO.uidKey);
        }
      } else {
        swal({
          title: '',
          text: '비밀번호가 일치하지 않습니다.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        });
      }
    },
    //댓글 수정 단추 클릭 이벤트
    onClickMentoContentsReplyUpdate: function (replyVO) {
      let vm = this;
      vm.mentoGroupModel.replyUidKey = replyVO.uidKey;
      if (replyVO.userKey === 'GUEST') {
        vm.mentoGroupModel.replyName = replyVO.guestName;
      } else {
        vm.mentoGroupModel.replyName = replyVO.nickName;
      }
      vm.mentoGroupModel.replyPassword = replyVO.guestPassword;
      vm.mentoGroupModel.replyUpdateContents = replyVO.content;
      vm.mentoGroupModel.replyStarCnt = replyVO.vote;
      vm.mentoGroupModel.isReplyUpdateOn = true;
      vm.mentoGroupModel.isButtonAction = false;
    },
    //대댓글 수정 단추 클릭 이벤트
    onClickMentoContentsReReplyUpdate: function (replyVO) {
      let vm = this;
      vm.mentoGroupModel.replyUidKey = replyVO.uidKey;
      if (replyVO.userKey === 'GUEST') {
        vm.mentoGroupModel.replyName = replyVO.guestName;
      } else {
        vm.mentoGroupModel.replyName = replyVO.nickName;
      }
      vm.mentoGroupModel.replyPassword = replyVO.guestPassword;
      vm.mentoGroupModel.replyUpdateContents = replyVO.content;
      vm.mentoGroupModel.isReReplyUpdateOn = true;
      vm.mentoGroupModel.isButtonAction = false;
    },
    //댓글 수정 호출 API
    onClickMentoContentsReplyUpdateSubmit: function (depth) {
      let vm = this;

      //유효성 체크
      let _IsContent = validation.isEmpty(vm.mentoGroupModel.replyUpdateContents);

      let _param = {
        uidKey: vm.mentoGroupModel.replyUidKey,
        vote: vm.mentoGroupModel.replyStarCnt,
        content: vm.mentoGroupModel.replyUpdateContents
      };
      let param = {param: _param};

      swal({
        text : "댓글을 수정하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if (result) {
          if (_IsContent) {
            let _word = '';
            _word = '내용';
            swal({
              title: _word + ' 오류',
              text: _word + '을 입력해주세요.',
            });
          } else {
            Axios.post("/api/realinfo/group/contents/reply/update", param).then(function (response) {
              let resultCnt = response.data.result;
              if (resultCnt > 0) {

                vm.onClickMentoCountetnsReplyCancle();

              } else if (resultCnt == -999) {
                swal({
                  title: '등록 실패',
                  text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                  // icon: vm.fnOnLoadSwalImageData('error'),
                  buttons: {
                    confirm: {
                      text: "확인",
                      value: true,
                      visible: true,
                    },
                  },
                  dangerMode: false
                }).then(result => {
                  if (result) {
                    return false;
                  }
                });
              } else {
                swal({
                  title: '수정 실패',
                  text: '댓글 수정이 실패하였습니다.',
                  // icon: this.fnOnLoadSwalImageData('error'),
                  buttons: {
                    confirm: {
                      text: "확인",
                      value: true,
                      visible: true,
                    }
                  },
                  dangerMode: false,
                });
              }
            }).catch(function (ex) {
              console.log(ex);
              swal({
                title: '수정 실패',
                text: '게시물 수정이 실패하였습니다.',
                // icon: this.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false,
              });
            });
          }
        }
      });

    },
    //댓글 삭제 호출 API
    onClickMentoContentsReplyDeleteSubmit: function (uidKey, depth) {
      let vm = this;
      swal({
        text: "댓글을 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: true
          }
        }
      }).then(result => {
        if (result) {
          let _param = {uidKey: uidKey};
          let param = {param: _param};
          Axios.post("/api/realinfo/group/contents/reply/delete", param).then(function (response) {
            let resultCnt = response.data.result;
            if (resultCnt > 0) {
              swal({
                text: `${depth == 0 ? "댓글" : "답글"} 삭제가 완료되었습니다.`,
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  vm.onClickMentoCountetnsReplyCancle();
                }
              });
            } else {
              swal({
                text: `${depth == 0 ? "댓글" : "답글"} 삭제가 실패하였습니다.`,
                // icon: this.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false,
              });
            }
          }).catch(function (ex) {
            console.log(ex);
            swal({
              title: '삭제 실패',
              text: `${depth == 0 ? "댓글" : "답글"} 삭제가 실패하였습니다.`,
              // icon: this.fnOnLoadSwalImageData('error'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false,
            });
          });
        }
      });
    },
    onClickMentoCountetnsReplyCancle: function () {
      let vm = this;
      vm.mentoGroupModel.replyName = '';
      vm.mentoGroupModel.replyPassword = '';
      vm.mentoGroupModel.replyContents = '';
      vm.mentoGroupModel.replyUidKey = '';
      vm.mentoGroupModel.replyStarCnt = 0;
      vm.mentoGroupModel.isReplyOn = false;
      vm.mentoGroupModel.isReplyUpdateOn = false;
      vm.mentoGroupModel.isReReplyOn = false;
      vm.mentoGroupModel.isReReplyUpdateOn = false;
      vm.mentoGroupModel.isButtonAction = true;
      vm.mentoGroupModel.docList = [];
      vm.mentoGroupModel.imgList = [];
      vm.mentoGroupModel.vdList = [];
      vm.fnGetMentoGroupMentoContentsDetail();
    },
    //이벤트 더보기 버튼
    OnClickEventMoreBtn: function (tab) {

      // retu 지정시 그쪽으로 가자.
      const qMap = Common.queryStringToMap()
      // console.log("qMap =", qMap)
      location.href = Common.ifBlank(qMap.retp, "/customer/notice?subTab=all&tabType=event")

      // const vm = this;
      // let pageName = $('#pageName').val();
      //
      // if (pageName === 'realinfoMain') {
      //   let pageNum = vm.viewModel.pager.pageNo;
      //   let tabIdx = 1;
      //
      //   if (vm.mainViewModel.isMentoContents) {
      //     tabIdx = 1;
      //   } else if (vm.mainViewModel.isSpecFacil) {
      //     tabIdx = 2;
      //   } else if (vm.mainViewModel.isYouthPolicy) {
      //     tabIdx = 3;
      //   } else if (vm.mainViewModel.isEvent) {
      //     tabIdx = 4;
      //   } else if (vm.mainViewModel.isPress) {
      //     tabIdx = 5;
      //   }
      //
      //   sessionStorage.setItem("URL", "/customer/realinfo?tabIdx=" + tabIdx + "&pageNum=" + pageNum);
      // }
      //
      // location.href = "/customer/realinfo/event/list?tab=" + tab;
    },

    //신고 등록
    fnSetReport: function () {
      let vm = this;
      let _uidKey = $("#uidKey").val();

      let _reason = vm.mentoGroupModel.reportValues;
      let _reasonEtc = '';

      if (_reason == null || _reason.trim() == "") {
        swal('신고사유를 선택해 주세요.');
        return false;
      }

      if (_reason === 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length == 0) {
        swal('기타사유를 입력해 주세요.');
        return false;
      } else if (_reason === 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length > 0) {
        _reasonEtc = vm.mentoGroupModel.reportEtcValue.trim();
      }

      let _param = {
        brdUidKey: _uidKey,
        reportKey: _reason,
        reportEtc: _reasonEtc
      };
      let param = {param: _param};
      Axios.post("/api/realinfo/group/contents/report", param).then(function (response) {
        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          swal("등록되었습니다.");
          setTimeout(function() {
            vm.OnClickMentoContentsReportClose();
          }, 500);
        } else if (resultCnt == -999) {
          swal({
            title: '신고 실패',
            text: '신고에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          swal({
            title: '신고 실패',
            text: '게시물 신고가 실패하였습니다.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        swal({
          title: '신고 실패',
          text: '게시물 신고가 실패하였습니다.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        }).then(result => {
          if (result) {
            swal({
              title: "",
              text: "확인을 부탁드립니다.",
              // icon: this.fnOnLoadSwalImageData('error'),
            })
            return false;
          }
        });
      });

    },
    //이벤트 당첨발표 콘텐츠 상세
    fnGetEventAnnounceContents: function () {
      let vm = this;
      let _uidKey = $("#uidKey").val();
      let _tab = $("#tab").val();

      vm.fnChgSubTabByEvent(_tab);

      let _param = {uidKey: _uidKey};
      let param = {param: _param};
      Axios.post("/api/realinfo/evnetAnnounce/detail", param).then(function (response) {
        vm.mentoGroupModel.eventVO = response.data.paramBrdDto;
        vm.mentoGroupModel.vdList = response.data.fileVdList;
        document.title = response.data.paramBrdDto.title;

        // 22.12.23 이벤트 구분(eventKey)이 선택되지 않은 경우, 참여하기 버튼을 감춘다
        vm.mentoGroupModel.isHideEventBtn = vm.mentoGroupModel.eventVO.eventKey == null || vm.mentoGroupModel.eventVO.eventKey === ''

        // 투표(EVTNVBANNV01300) 이벤트용 - 이미 참여하였다면, 투표 결과를 조회
        if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV01300' && vm.mentoGroupModel.eventVO.participation === 'Y') {
          vm.fnGetEventResult();
        }

        vm.fnGetBoardDetail();
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //이벤트 당첨발표 클릭
    OnClickEventAnnounceDetail(uidKey) {
      // let vm = this;
      // let pageName = $('#pageName').val();

      // if(pageName === 'realinfoMain'){
      //   let pageNum = vm.viewModel.pager.pageNo;
      //   let tabIdx = 1;
      //
      //   if(vm.mainViewModel.isMentoContents){
      //     tabIdx = 1;
      //   }else if(vm.mainViewModel.isSpecFacil){
      //     tabIdx = 2;
      //   }else if(vm.mainViewModel.isYouthPolicy){
      //     tabIdx = 3;
      //   }else if(vm.mainViewModel.isEvent){
      //     tabIdx = 4;
      //   }else if(vm.mainViewModel.isPress){
      //     tabIdx = 5;
      //   }
      //
      //   sessionStorage.setItem("URL", "/customer/realinfo?tabIdx="+ tabIdx + "&pageNum="+pageNum);
      // }else if(pageName === 'eventList'){
      //   let pageNum = vm.viewModel.pager.pageNo;
      //   let tab = 1;
      //
      //   if(vm.mainViewModel.subCatCd === 'BRDNVYTHNV00220'){
      //     tab = 2;
      //   }
      //
      //
      //   sessionStorage.setItem("URL", "/customer/realinfo/event/list?tab="+ tab + "&pageNum="+pageNum);
      // }

      location.href = "/customer/realinfo/eventAnnounce?uidKey=" + uidKey;
    },
    //메인화면 이벤트 화면으로 이동
    onClickEventAnnounceList: function (tab) {
      location.href = "/customer/realinfo?tab=" + tab;
    },
    //페이징 처리
    fnSetPager: function (totalCount, etc) {
      let vm = this;
      vm.viewModel.pager.etc = etc
      vm.viewModel.pager.totalSize = totalCount;
      vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
      Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
    },

    //좋아요 처리
    fnChgLikeBtn: function (object) {
      //로그인 체크
      let vm = this;
      let _userKey = $("#loginUserKey").val();

      if (this.fnIsEmptyChk(_userKey)) {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      } else {
        //로그인이 되어 있으면
        object.isLike = !object.isLike;
        vm.mainViewModel.youthFacltVO.isLike = object.isLike;
        if (object.isLike) {
          object.likeCnt++;
        } else {
          object.likeCnt--;
        }
        let _param = {
          uidKey: object.uidKey,
          rcmmUidKey: object.rcmmUidKey,
          isLike: object.isLike
        };
        let param = {param: _param};
        Axios.post("/api/realinfo/contents/like/update", param).then(function (response) {
          let result = response.data.result
        }).catch(function (ex) {
          console.log(ex);
        });
      }
    },
    //이벤트 서브탭 변경
    fnChgSubTabByEvent: function (num) {
      let vm = this;

      Common.fnLocationBarChangeQuery({tab: num, pageNum: null})
      if (num == 1) {
        vm.eventViewModel.isFrst = true;
        vm.eventViewModel.isScnd = false;
        vm.mainViewModel.subCatCd = 'BRDNVYTHNV00210';
        vm.fnGetEventBySub(1);
      } else {
        vm.eventViewModel.isFrst = false;
        vm.eventViewModel.isScnd = true;
        vm.mainViewModel.subCatCd = 'BRDNVYTHNV00220';
        vm.fnGetEventBySub(1);
      }
    },
    //이벤트 서브탭 변경
    fnChgSubTabByEventBackspace: function (num, pageNum) {
      let vm = this;

      if (num == 1) {
        vm.eventViewModel.isFrst = true;
        vm.eventViewModel.isScnd = false;
        vm.mainViewModel.subCatCd = 'BRDNVYTHNV00210';
        vm.fnGetEventBySub(pageNum);
      } else {
        vm.eventViewModel.isFrst = false;
        vm.eventViewModel.isScnd = true;
        vm.mainViewModel.subCatCd = 'BRDNVYTHNV00220';
        vm.fnGetEventBySub(pageNum);
      }
    },
    fnEvtLoginBtn: function () {
      //로그인 체크
      let vm = this;
      let _userKey = $("#loginUserKey").val();

      if (this.fnIsEmptyChk(_userKey)) {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      }
    },
    //이벤트 참여 버튼
    fnSetEventParticipation: function (_uidKey) {
      let vm = this;
      let _param = {};
      console.log(vm.mentoGroupModel.eventVO.eventKey);

      // 사진(파일) 등록 이벤트의 경우, 첨부파일 필수체크
      if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00800' && vm.$refs.img.cnt < 1) {
        return swal({
          text: "이미지를 등록해주세요.",
          icon: this.fnOnLoadSwalImageData('error'),
          buttons: {confirm: {text: "확인"}},
          dangerMode: false,
        });
      }

      if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV01000') {
        _param = {brdUidKey: _uidKey, evtCode: vm.mentoGroupModel.eventVO.eventKey, evtVal5: 'Y'};
      } else {
        if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00600') {
          _param = {
            brdUidKey: _uidKey,
            evtCode: vm.mentoGroupModel.eventVO.eventKey,
            evtVal5: vm.selectDetailInf.evt11,
            evtVal6: vm.selectDetailInf.evt21 + vm.selectDetailInf.evt22 + vm.selectDetailInf.evt23,
            evtVal7: vm.selectDetailInf.evt31 + '@' + vm.selectDetailInf.evt32,
            evtVal8: vm.selectDetailInf.evt41 + ' ' + vm.selectDetailInf.evt42
          };

        } else if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00800') { // 사진(파일) 등록 이벤트
          _param = {
            brdUidKey: _uidKey,
            evtCode: vm.mentoGroupModel.eventVO.eventKey,
            fileKey: $('#fileKey').val(),
          };

        } else if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00900') {
          _param = {
            brdUidKey: _uidKey,
            evtCode: vm.mentoGroupModel.eventVO.eventKey,
            evtVal5: vm.selectDetailInf.evt21,
            evtVal6: vm.selectDetailInf.evt31,
            fileKey: $('#fileKey').val(),
          };

        } else {
          if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00100' || vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00200' ||
            vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV01300') {

            if (vm.selectDetailInfList.evt51.some(function (ans) { return vm.fnIsEmptyChk(ans); })) {
              return swal({
                text: "답변을 입력해주세요.",
                //icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {confirm: {text: "확인"}},
                dangerMode: false,
              });
            }

            vm.selectDetailInf.evt31 = vm.selectDetailInfList.evt51.join(",");
            /* for(let i=0; i<vm.selectDetailInfList.evt51.length; i++){
                            if(vm.selectDetailInfList.evt51[i].split("|").length > 1){

                                // vm.selectDetailInf.evt31 = vm.onChangeEvtValues(vm.selectDetailInfList.evt41[i], vm.selectDetailInfList.evt51[i]);
                                vm.selectDetailInf.evt31
                            }else{
                                vm.selectDetailInf.evt31 = vm.selectDetailInfList.evt51[i]
                            }

                        }   */
          }

          _param = {
            brdUidKey: _uidKey,
            evtCode: vm.mentoGroupModel.eventVO.eventKey,
            evtVal1: vm.selectDetailInf.evt11,
            evtVal2: vm.selectDetailInf.evt21,
            evtVal3: vm.selectDetailInf.evt31,
            evtVal4: vm.selectDetailInf.evt41
          };
          console.log(_param);
        }
      }

      let param = {param: _param};
      Axios.post("/api/realinfo/event/participte/create", param).then(function (response) {
        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          vm.isEvent = false;
          swal({
            title: '이벤트 참가 신청 완료',
            text: '이벤트 참가 신청이 완료되었습니다.',
            // icon: vm.fnOnLoadSwalImageData('success'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          });
          vm.isEvent = false;
          vm.fnGetEventAnnounceContents();
        } else {
          vm.isEvent = false;
          swal({
            title: '이벤트 참가 신청 실패',
            text: '이벤트 참가 신청이 실패하였습니다. 관리자에게 문의하세요.',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.isEvent = false;
        swal({
          title: '이벤트 참가 신청 실패',
          text: '이벤트 참가 신청이 실패하였습니다. 관리자에게 문의하세요. (1)',
          // icon: vm.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false
        }).then(result => {
          if (result) {
            return false;
          }
        });
      });
    },

    fnGetEmailCode: function () {
      console.log("참여(주소입력)")

      let vm = this;
      Axios.post("/api/admin/code/sys/list", {paramCodeGrp: "EMLNVCOMNV00000"})
      .then(function (response) {
        vm.listEmailCodes = response.data.listCodeSys;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnChangeEmailAddr: function (item) {
      this.selectedEmail = item;
      if(item != null) {

        this.selectDetailInf.evt32 = this.selectedEmail.cmm_sys_titl;
        let _valid = this.selectDetailInf.evt31 + "@" + this.selectDetailInf.evt32;
      } else {
        this.selectDetailInf.evt32 = '';
      }

      // this.validateTxtEmail = (_valid != '') ? Validator.methods.fnValidateEmail(_valid) : '';
      // this.isTxtUserEmail = (this.validateTxtEmail != '정상입력되었습니다.') ? false : true;
    },
    fnOnChangeCheckEmail: function () {
      let _valid = this.selectDetailInf.evt31 + "@" + this.selectDetailInf.evt32;
      //this.validateTxtEmail = (_valid != '') ? Validator.methods.fnValidateEmail(_valid) : '';
      //this.isTxtUserEmail = (this.validateTxtEmail != '정상입력되었습니다.') ? false : true;
    },
    fnOnCickAddress: function () {
      // 현재 scroll 위치를 저장해놓는다.
      const element_wrap = document.getElementById('wrapList');
      let vm = this;
      var currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      new kakao.Postcode({
        oncomplete: function (data) {

          // 카카오 iframe api 참고
          var addr = ''; // 주소 변수
          var extraAddr = ''; // 참고항목 변수

          if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }

          if (data.userSelectedType === 'R') {

            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
            }
            if (data.buildingName !== '' && data.apartment === 'Y') {
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            if (extraAddr !== '') {
              extraAddr = ' (' + extraAddr + ')';
            }
            vm.selectDetailInf.evt41 = extraAddr;

          } else {
            vm.selectDetailInf.evt41 = '';
          }


          vm.selectDetailInf.evt41 = (vm.selectDetailInf.evt41 === '') ? addr : vm.selectDetailInf.evt41 + " " + addr;

          element_wrap.style.display = 'none';

          document.body.scrollTop = currentScroll;
        },
        onresize: function (size) {
          element_wrap.style.height = size.height + 'px';
        },
        width: '100%',
        height: '100%'
      }).embed(element_wrap);
      // iframe을 넣은 element를 보이게 한다.
      element_wrap.style.display = 'block';
    },
    //이벤트 참여했을 시

    onClickClosePopupEvent: function () {
      this.isEvent = false;
      this.selectDetailInf = {evt11: '', evt21: '', evt22: '', evt23: '', evt31: '', evt32: '', evt41: '', evt42: ''};
      this.selectDetailInfList = {
        evt11: [],
        evt21: [],
        evt22: [],
        evt23: [],
        evt31: [],
        evt32: [],
        evt41: [],
        evt42: [],
        evt51: [],
        evt52: []
      };
    },
    //이벤트 참여 이력 조회
    onClickPopupEvnetParticipate: function (_uidKey) {
      console.log(_uidKey);
      this.isEvent = true;
      this.selectDetailInf.evt11 = this.commonParams.loginUserNickName;

      $(".pop_wrapper").draggable();
      if (this.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00600') {
        this.fnGetEmailCode();
      }
      if (this.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00300') {
        this.onLoadWinwheelList();
      }
      if (this.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00100' || this.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00200' ||
        this.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV01300') {
        this.onLoadQuizAndSurveyList();
      }

    },
    onLoadWinwheelList: function () {
      console.log("룰렛")

      let vm = this;
      let _param = {uidKey: vm.mentoGroupModel.eventVO.uidKey};
      let param = {paramText: JSON.stringify(_param)};
      let _list = [];
      Axios.post("/api/event/basic/survey/list", param).then(function (response) {

        console.log(response);
        console.log(response.data.evtList);

        let _angleCnt = 360 / response.data.evtList.length;


        // response.data.evtList.forEach(function(item, idx){
        //     //   let _start = idx * _angleCnt;
        //     //   let _end =  (idx + 1) * _angleCnt;
        //     // _list.push({text : item.title, startAngle: _start, endAngle: _end, code: item.brdCtg, uidKey : item.uidKey});

        //     _list.push(item.title);
        // });

        vm.listWheel = response.data.evtList;
        // vm.$children[0].winwheel.rotationAngle = 0;
        // vm.$children[0].winwheel.segments = _list;
        //vm.$children[0].winwheel.draw();
        //vm.$children[0].list = _list;
        $("#wheelDiv").draggable();
      }).catch(function (ex) {
        console.log(ex);
      });

    },
    onClickEventWinwheel: function () {
      let vm = this;
      let _param = {uidKey: vm.mentoGroupModel.eventVO.uidKey};
      let param = {paramText: JSON.stringify(_param)};
      let prizeChk = false;

      Axios.post("/api/event/basic/survey/list", param).then(response => {
        console.log(response);
        let curEvnt = response.data.evtList;

        for (var i = 0; i < curEvnt.length; i++) {
          if (curEvnt[i].winnerCnt < curEvnt[i].count) {
            prizeChk = true;
          } else if (curEvnt[i].count == -1) {
            prizeChk = true;
          }
        }

        if (prizeChk) {
          let winner = this.fnCalRoulette(curEvnt);
          if (winner == -1) {
            swal({
              title: '이벤트 참가 신청 실패',
              text: '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              // icon: vm.fnOnLoadSwalImageData('error')
            });
            return;
          }
          this.fnWinwheelParticipation(curEvnt[winner], winner);

        } else {
          console.log("이벤트가 종료되었습니다.")
          swal({
            title: '다음 기회에 이용해주세요.',
            text: '모든 상품이 소진되었습니다.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              }

            },
            dangerMode: false
          }).then(result => {
            if (result) {
              this.onClickClosePopupEvent();
            }
          });
        }
      }).catch(function (ex) {
        console.log("onClickEventWinwheel ex : ", ex);
      });
    },
    onClickChkParticipation() {
      const vm = this
      let isSts = false
      const _userKey = $("#userKey").val();
      const _uidKey = $("#uidKey").val();
      let _param = {
        uidKey: _uidKey,
        userKey: _userKey,
      }
      let param = {param: _param};

      Axios.post("/api/realinfo/evnetAnnounce/detail", param).then(response => {
        const chkPrtcp = response.data.paramBrdDto.participation
        console.log('참여 여부 : ', chkPrtcp)

        if (chkPrtcp === 'Y') {
          swal({
            title: '이벤트 참가 신청 실패',
            text: '이미 참여한 이벤트입니다.',
            // icon: vm.fnOnLoadSwalImageData('error')
          })
          return

        } else {
          vm.onClickEventWinwheel()
        }
      })
    },

    fnCalRoulette(curEvnt) {
      let cnt = [];
      let winnerCnt = [];
      let winProb = [];
      let totalProb = 0;

      for (var i = 0; i < curEvnt.length; i++) {
        cnt[i] = curEvnt[i].count;
        winnerCnt[i] = curEvnt[i].winnerCnt;
        winProb[i] = parseInt(curEvnt[i].content);

        if (cnt[i] > winnerCnt[i]) {
          totalProb += winProb[i];
        } else {
          winProb[i] = 0;
        }
      }

      const randomNum = Math.random() * totalProb;
      let tempProb = 0;
      console.log(randomNum);
      console.log(winProb);

      for (var i = 0; i < curEvnt.length; i++) {
        if (randomNum >= tempProb && randomNum < tempProb + winProb[i]) {
          return i;
        } else {
          tempProb += winProb[i];
        }
      }

      return -1;
    },
    fnGetResult(e) {
      let vm = this;
      vm.wheelResult = e;
    },
    fnWinwheelParticipation: function (item, winner) {
      let vm = this;
      console.log("item : ", item);

      let _param = {};
      console.log(vm.mentoGroupModel.eventVO.eventKey);
      if (vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00300' || vm.mentoGroupModel.eventVO.eventKey === 'EVTNVBANNV00400') {
        _param = {
          brdUidKey: item.uidKey,
          evtCode: vm.mentoGroupModel.eventVO.eventKey,
          evtVal1: item.brdCtg,
          evtVal2: item.title
        };
      }

      let param = {param: _param};
      Axios.post("/api/realinfo/event/participte/create", param).then(response => {
        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          this.$refs.winwheel.spin(winner);
          setTimeout(() => {
            swal({
              title: item.title + " 당첨!",
              text: '이벤트 참가가 완료되었습니다!',
              // icon: vm.fnOnLoadSwalImageData('success'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false,
                }

              },
              dangerMode: false
            });
            vm.isEvent = false;
            vm.fnGetEventAnnounceContents();
          }, 4800);

        } else {
          swal({
            title: '이벤트 참가 신청 실패',
            text: '이벤트 참가 신청이 실패하였습니다.',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        swal({
          title: '이벤트 참가 신청 실패',
          text: '이벤트 참가 신청이 실패하였습니다.',
          // icon: vm.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false
        }).then(result => {
          if (result) {
            return false;
          }
        });
      });
    },
    onLoadQuizAndSurveyList: function () {
      console.log("퀴즈, 설문")

      let vm = this;
      let _param = {uidKey: vm.mentoGroupModel.eventVO.uidKey};
      let param = {paramText: JSON.stringify(_param)};
      let _list = [];
      Axios.post("/api/event/basic/survey/list", param).then(function (response) {
        console.log(response);
        if (response.data.evtList.length > 0) {
          response.data.evtList.forEach(function (item, idx) {
            vm.selectDetailInfList.evt11.push(item.brdCtg);
            vm.selectDetailInfList.evt21.push(item.title);
            vm.selectDetailInfList.evt41.push(item.content);
            if (item.content.split("|").length > 0) {
              vm.selectDetailInfList.evt51[idx] = '';
            } else {
              vm.selectDetailInfList.evt51[idx] = '';
            }

          });
        }
        /*     vm.selectDetailInf.evt11 = response.data.evtList[0].brdCtg;
                vm.selectDetailInf.evt21 = response.data.evtList[0].title;
                vm.selectDetailInf.evt41 = response.data.evtList[0].content;
                vm.selectDetailInf.evt42 = response.data.evtList[0].content; */

      }).catch(function (ex) {
        console.log(ex);
      });

    },
    fnChangeModel(idx, idxs, _item) {
      console.log(idx);
      console.log(_item);
    },
    onChangeEvtValues: function (list, val) {
      let vm = this;
      let _value = '';
      let _list = list.split('|');
      console.log(item);
      console.log(val);
      _list.forEach(function (item) {

        let _yn = (item == val) ? 'Y' : 'N';
        _value = (_value === '') ? _yn : _value + '|' + _yn;
      });
      return _value;
    },
    onClickEvnetParticipate: function (_uidKey) {
      let vm = this;
      let _userKey = $("#loginUserKey").val();
      if (this.fnIsEmptyChk(_userKey)) {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      } else {
        let _param = {brdUidKey: _uidKey};
        let param = {param: _param};
        Axios.post("/api/realinfo/event/history/select", param).then(function (response) {
          let resultCnt = response.data.result;
          if (resultCnt > 0) {
            swal({
              title: '',
              text: '이미 참가하셨습니다.',
              // // icon: vm.fnOnLoadSwalImageData('warning'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSetEventParticipation(_uidKey);
          }
        }).catch(function (ex) {
          console.log(ex);
          return false;
        });
      }
    },
    //멘토 프로필 조회
    fnGetMentoProfile: function () {
      let vm = this;
      let _param = {};
      let param = {param: _param};
      Axios.post("/api/realinfo/mynavi/mentoinfo/select", param).then(function (response) {
        vm.mynaviModel.mentoVo = response.data.mentoVO;
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },
    //멘토 프로필 수정
    onClickMentoProfileUpdate: function () {
      let vm = this;
      let _param = {
        nickName: vm.mynaviModel.mentoVo.nickName,
        mentoIntro: vm.mynaviModel.mentoVo.mentoIntro,
        userImage: $('#fileKey').val()
      };
      let param = {param: _param};
      Axios.post("/api/realinfo/mynavi/mentoinfo/update", param).then(function (response) {

        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          swal({
            title: '수정 완료',
            text: '프로필 수정이 완료되었습니다.',
            // icon: vm.fnOnLoadSwalImageData('success'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            location.href = "/youthnavi/mypage/user/mypageUserParent";
          });
        } else {
          swal({
            title: '수정 실패',
            text: '프로필 수정이 실패하였습니다.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        swal({
          title: '수정 실패',
          text: '프로필 수정이 실패하였습니다.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        });
      });

    },
    //멘토 프로필 이미지 수정
    onClickMentoProfileImageUpdate: function () {
      let vm = this;
      vm.mynaviViewModel.isProfileUpdate = !vm.mynaviViewModel.isProfileUpdate;
    },

    //마이네비 멘토 콘텐츠 목록 조회
    fnGetMentoContentList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {
        keyword: vm.mynaviModel.keyword,
        startDate: vm.fnChgDateString(vm.mynaviModel.startDate),
        endDate: vm.fnChgDateString(vm.mynaviModel.endDate)
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      if(vm.viewModel.pager.pageNo == 1) {
        vm.mynaviModel.contentList = [];
      }
      Axios.post("/api/realinfo/mynavi/content/list", param).then(function (response) {
        vm.mynaviModel.contentList = vm.mynaviModel.contentList.concat(response.data.paramBrdDtoList);
        vm.mynaviModel.contentListCnt = response.data.paramBrdDtoListCnt;

        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMentoContentList');
        if(response.data.paramBrdDtoListCnt == vm.mynaviModel.contentList.length) {
          vm.showMore = false;
        } else {
          vm.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },

    //마이네비 참여내역 목록 조회
    fnGetMyReplyList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {
        keyword: vm.mynaviModel.keyword,
        startDate: vm.fnChgDateString(vm.mynaviModel.startDate),
        endDate: vm.fnChgDateString(vm.mynaviModel.endDate)
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      Axios.post("/api/realinfo/mynavi/reply/list", param).then(function (response) {
        vm.mynaviModel.contentList = response.data.replyList;
        vm.mynaviModel.contentListCnt = response.data.paramBrdDtoListCnt;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMyReplyList');
        if(response.data.paramBrdDtoListCnt == vm.mynaviModel.contentList.length) {
          vm.showMore = false;
        } else {
          vm.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },

    //날자값 변경
    fnChgDateString: function (_date) {
      if (_date != null && _date != '') {
        let tempDate = new Date(_date);
        let year = tempDate.getFullYear();
        let tmpMonth = tempDate.getMonth() + 1;
        let tmpDate = parseInt(tempDate.getDate());
        // let year = _date.getFullYear();
        // let tmpMonth = _date.getMonth()+1;
        // let tmpDate = parseInt(_date.getDate());
        let date = '';
        let month = '';
        if (tmpMonth < 10) {
          month = "0" + tmpMonth;
        } else {
          month = tmpMonth;
        }
        if (tmpDate < 10) {
          date = "0" + tmpDate;
        } else {
          date = tmpDate;
        }
        return year + "-" + month + "-" + date
      }
    },
    //개월 버튼
    onClickDateBtn: function (num) {
      let vm = this;
      let date = new Date();
      let _date = new Date();
      if (num == 1) {
        vm.mynaviModel.startDate = _date;
        vm.mynaviModel.endDate = date;
        vm.mynaviViewModel.isToday = true;
        vm.mynaviViewModel.isWeek = false;
        vm.mynaviViewModel.isOneMonth = false;
        vm.mynaviViewModel.isTwoMonth = false;
        vm.mynaviViewModel.isSixMonth = false;
      } else if (num == 2) {
        vm.mynaviModel.endDate = _date;
        vm.mynaviModel.startDate = new Date(date.setDate(date.getDate() - 7));
        vm.mynaviViewModel.isToday = false;
        vm.mynaviViewModel.isWeek = true;
        vm.mynaviViewModel.isOneMonth = false;
        vm.mynaviViewModel.isTwoMonth = false;
        vm.mynaviViewModel.isSixMonth = false;
      } else if (num == 3) {
        vm.mynaviModel.endDate = _date;
        vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth() - 1));
        vm.mynaviViewModel.isToday = false;
        vm.mynaviViewModel.isWeek = false;
        vm.mynaviViewModel.isOneMonth = true;
        vm.mynaviViewModel.isTwoMonth = false;
        vm.mynaviViewModel.isSixMonth = false;
      } else if (num == 4) {
        vm.mynaviModel.endDate = _date;
        vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth() - 2));
        vm.mynaviViewModel.isToday = false;
        vm.mynaviViewModel.isWeek = false;
        vm.mynaviViewModel.isOneMonth = false;
        vm.mynaviViewModel.isTwoMonth = true;
        vm.mynaviViewModel.isSixMonth = false;
      } else if (num == 5) {
        vm.mynaviModel.endDate = _date;
        vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth() - 6));
        vm.mynaviViewModel.isToday = false;
        vm.mynaviViewModel.isWeek = false;
        vm.mynaviViewModel.isOneMonth = false;
        vm.mynaviViewModel.isTwoMonth = true;
        vm.mynaviViewModel.isSixMonth = false;
      } else if (num == 6) {
        vm.mynaviModel.endDate = '';
        vm.mynaviModel.startDate = '';
        vm.mynaviModel.keyword = '';
        vm.mynaviViewModel.isToday = false;
        vm.mynaviViewModel.isWeek = false;
        vm.mynaviViewModel.isOneMonth = false;
        vm.mynaviViewModel.isTwoMonth = false;
        vm.mynaviViewModel.isSixMonth = false;
      }
    },
    //전문가 콘텐츠 작성 페이지
    fnGetContentCategory: function () {
      let vm = this;
      let param = {};
      Axios.post("/api/realinfo/content/category", param).then(function (response) {
        response.data.paramCdDtoList.forEach(function (item) {
          let val = {code: item.code, value: item.codeName}
          vm.postingModel.categoryList.push(val);
        });
      }).catch(function (ex) {
        console.log(ex);
      });
      vm.mynaviModel.insertDate = new Date();
    },
    //알통정보 콘텐츠 등록
    fnSetContent: function () {
      let vm = this;
      let _fileKey = $('#fileKey').val();
      if (vm.videoRes.resValue != null && vm.videoRes.resValue !== "succ") {
        alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        return false;
      }
      //유효성 체크
      let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
      let _IsContent = validation.isEmpty(vm.mynaviModel.content);
      let _IsInsrtDt = validation.isEmpty(vm.mynaviModel.insertDate.toString());
      let _IsSubGroup = validation.isEmpty(vm.postingModel.code);
      let _IsContentType = validation.isEmpty(vm.mynaviModel.type);
      let _IsLink = Validator.methods.fnValidateHmpg(vm.mynaviModel.link);

      if (!_IsLink) {
        if (vm.mynaviModel.link === 'http://'
          || vm.mynaviModel.link === 'https://'
          || vm.mynaviModel.link === '') {

          vm.mynaviModel.link = '';
          _IsLink = true;
        }
      }

      let _param = {
        title: vm.mynaviModel.title,
        content: vm.mynaviModel.content,
        link: vm.mynaviModel.link,
        group: 'BRDNVYTHNV00500',
        insertDate: new Date(vm.mynaviModel.insertDate.toString()),
        subGroup: vm.postingModel.code,
        fileKey: _fileKey,
        contentType: vm.mynaviModel.type,
        video: vm.mynaviModel.video,
        type: "insert"
      };
      let param = {param: _param};
      if (_IsTitle
        || _IsContent
        || _IsInsrtDt
        || _IsSubGroup
        || _IsContentType) {

        let _word = '';
        if (_IsTitle) {
          _word = '제목';
        } else if (_IsContent) {
          _word = '내용';
        } else if (_IsInsrtDt) {
          _word = '작성일';
        } else if (_IsSubGroup) {
          _word = '카테고리';
        } else if (_IsContentType) {
          _word = '방식';
        }

        if (_IsContentType) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 선택해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        } else if (_IsTitle || _IsContent) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 입력해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });

        } else if (_IsInsrtDt || _IsSubGroup) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 선택해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        }
      } else if (!_IsLink) {
        swal({
          text: '관련링크에 입력된 주소를 확인해주세요.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        });
      } else {
        if (vm.mynaviModel.title.length > 200) {
          swal({
            title: '제목 길이 오류',
            text: '제목은 200자 이하로 입력해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        } else {
          Axios.post("/api/realinfo/mynavi/mento/content/write", param).then(function (response) {
            let resultCnt = response.data.result;
            if (resultCnt > 0) {
              vm.fnCallImgAltSave();
              swal({
                title: '등록 완료',
                text: '게시물 등록이 완료되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                vm.onClickContentList();
              });
            } else if (resultCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              swal({
                title: '등록 실패',
                text: '게시물 등록이 실패하였습니다.',
                // icon: this.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false,
              });
            }
          }).catch(function (ex) {
            swal({
              title: '등록 실패',
              text: '게시물 등록이 실패하였습니다.',
              // icon: this.fnOnLoadSwalImageData('error'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false,
            });
          });
        }
      }
    },
    //전문가 콘텐츠 수정
    fnChgContent: function (_type) {
      let vm = this;
      let _uidKey = $('#uidKey').val();
      if (vm.videoRes.resValue != null && vm.videoRes.resValue !== "succ") {
        alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        return false;
      }

      //유효성 체크
      let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
      let _IsContent = validation.isEmpty(vm.mynaviModel.content);
      let _date = vm.mynaviModel.insertDate;
      let _IsInsrtDt = false;
      if (vm.mynaviModel.link == null) vm.mynaviModel.link = '';
      let _IsLink = Validator.methods.fnValidateHmpg(vm.mynaviModel.link);

      if (!_IsLink) {
        if (vm.mynaviModel.link === 'http://'
          || vm.mynaviModel.link === 'https://'
          || vm.mynaviModel.link === '') {

          vm.mynaviModel.link = '';
          _IsLink = true;
        }
      }
      if (_date == null) {
        _IsInsrtDt = true;
      } else {
        _IsInsrtDt = validation.isEmpty(new Date(_date).toString());
      }
      let _IsSubGroup = validation.isEmpty(vm.postingModel.code);
      let _IsContentType = validation.isEmpty(vm.mynaviModel.type);
      let _param = {
        title: vm.mynaviModel.title,
        content: vm.mynaviModel.content,
        link: vm.mynaviModel.link,     // 관련링크 항목
        insertDate: vm.mynaviModel.insertDate,
        subGroup: vm.postingModel.code,
        contentType: vm.mynaviModel.type,
        uidKey: _uidKey,
        fileKey: $('#fileKey').val(),
        type: "update"
      };
      let param = {param: _param};
      if (_type === 'update' && (
        _IsTitle
        || _IsContent
        || _IsInsrtDt
        || _IsSubGroup
        || _IsContentType)) {

        let _word = '';
        if (_IsTitle) {
          _word = '제목';
        } else if (_IsContent) {
          _word = '내용';
        } else if (_IsInsrtDt) {
          _word = '작성일';
        } else if (_IsSubGroup) {
          _word = '카테고리';
        } else if (_IsContentType) {
          _word = '방식';
        }

        if (_IsContentType) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 선택해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        } else if (_IsTitle || _IsContent) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 입력해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        } else if (_IsInsrtDt || _IsSubGroup) {
          swal({
            title: _word + ' 오류',
            text: _word + '을 선택해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        }
      } else if (!_IsLink) {
        swal({
          text: '관련링크에 입력된 주소를 확인해주세요.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        });
      } else {
        if (_type === 'update' && vm.mynaviModel.title.length > 200) {
          swal({
            title: '제목 길이 오류',
            text: '제목은 200자 이하로 입력해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        } else {
          Axios.post("/api/realinfo/mynavi/mento/content/update", param).then(function (response) {
            let resultCnt = response.data.result;
            let word = '';
            if (_type === 'update') {
              word = '수정'
            } else if (_type === 'delete') {
              word = '삭제'
            }

            if (resultCnt > 0) {
              if (_type === 'update') vm.fnCallImgAltSave();
              swal({
                title: word + ' 완료',
                text: '게시물 ' + word + '이 완료되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                vm.onClickContentList();
              });
            } else if (resultCnt == -999) {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              swal({
                title: word + ' 실패',
                text: '게시물 ' + word + '이 실패되었습니다.',
                // icon: this.fnOnLoadSwalImageData('error'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false,
              });
            }
          }).catch(function (ex) {
            swal({
              title: word + ' 실패',
              text: '게시물 ' + word + '이 실패하였습니다.',
              // icon: this.fnOnLoadSwalImageData('error'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false,
            });
          });
        }
      }
    },
    //전문가 콘텐츠 수정 페이지
    fnGetMentoContent: function (_uidKey) {
      let vm = this;
      let _param = {uidKey: _uidKey};
      let param = {param: _param};
      Axios.post("/api/realinfo/mynavi/mento/content/select", param).then(function (response) {

        let tmp = response.data.paramBrdDto;
        vm.mynaviModel.title = tmp.title;
        vm.mynaviModel.insertDate = new Date(tmp.insertDate);
        vm.mynaviModel.content = tmp.contentFirst;
        vm.mynaviModel.link = tmp.link;
        vm.mynaviModel.type = tmp.type;
        vm.postingModel.code = tmp.subCategory;
        if (vm.postingModel.categoryList.length > 0) {
          vm.postingModel.categoryList.forEach(function (object) {
            if (object.code == tmp.subCategory) {
              vm.selectSubCatBoxInContentList = object;
            }
          });
        }

        vm.mentoGroupModel.docList = response.data.fileEtcList;
        vm.mentoGroupModel.imgList = response.data.fileImgList;
        vm.mentoGroupModel.vdList = response.data.fileVdList;

        if (vm.mentoGroupModel.docList.length > 0) {
          vm.mentoGroupModel.docList.forEach(function (file) {
            file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mentoGroupModel.imgList.length > 0) {
          vm.mentoGroupModel.imgList.forEach(function (file) {
            file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mentoGroupModel.vdList.length > 0) {
          vm.mentoGroupModel.vdList.forEach(function (file) {
            file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },
    //멘토 콘텐츠 목록
    onClickContentList: function () {
      let vm = this;
      vm.mynaviModel.title = '';
      vm.mynaviModel.content = '';
      vm.postingModel.code = '';
      vm.mynaviModel.startDate = '';
      location.href = "/customer/realinfo?tabIdx=1";
    },
    //멘토 콘텐츠 작성페이지
    onClickContentWrite: function () {
      location.href = "/mynavi/realinfo/mento/content/write";
    },
    //멘토 콘텐츠 수정페이지
    onClickContentUpdate: function (uidKey) {
      location.href = "/mynavi/realinfo/mento/content/update?uidKey=" + uidKey;
    },
    //에디터 사용
    onEditorChange: function (event) {
      let vm = this;
      let _pageName = $('#pageName').val();
      if (_pageName === "expInfoMentoProfile") { // 내비쌤 프로필
        vm.expMentoModel.intr = event.html;
      } else {
        vm.mynaviModel.content = event.html;
      }
      this.$emit("getEditorInfo", event);
    },
    //alert 이미지 호출
    fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    },
    //empty체크
    fnIsEmptyChk: function (val) {
      if (val === "" || val === null || val === undefined || (val !== null && typeof val === "object" && !Object.keys(val).length)) {
        return true;
      } else {
        return false;
      }
    },
    //마이내비 이벤트 관리
    fnGetMynaviEventList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {};
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }

      Axios.post("/api/realinfo/mynavi/event/list", param).then(function (response) {
        vm.mynaviModel.eventList = response.data.paramBrdDtoList;
        vm.mynaviModel.envetListCnt = response.data.paramBrdDtoListCnt;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMynaviEventList');

      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },
    //마이내비 청소년기관스페셜 목록
    fnGetMynaviOrganizationList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
      vm.viewModel.pager.blockSize = 5;
      vm.viewModel.pager.pageNo = pageNumber;
      let _param = {
        keyword: vm.mynaviModel.keyword,
        startDate: vm.fnChgDateString(vm.mynaviModel.startDate),
        endDate: vm.fnChgDateString(vm.mynaviModel.endDate)
      }
      let param = {
        param: _param,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize
      }
      if(vm.viewModel.pager.pageNo == 1) {
        vm.mynaviModel.contentList = [];
      }
      Axios.post("/api/realinfo/mynavi/organization/list", param).then(function (response) {
        vm.mynaviModel.contentList = vm.mynaviModel.contentList.concat(response.data.paramBrdDtoList);
        vm.mynaviModel.contentListCnt = response.data.paramBrdDtoListCnt;
        vm.fnSetPager(response.data.paramBrdDtoListCnt, 'fnGetMynaviOrganizationList');
        if(response.data.paramBrdDtoListCnt == vm.mynaviModel.contentList.length) {
          vm.showMore = false;
        } else {
          vm.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },
    fnChangeApprove(item) {
      let vm = this;

      if (item.approve === 'approve') {
        return "승인완료";
      } else if (item.approve === 'ready') {
        return "승인대기";
      } else if (item.approve === 'reject') {
        return "미승인";
      } else {
        return "-";
      }
    },
    //청소년기관스페셜 콘텐츠 작성페이지
    onClickYouthOrganizationWrite: function () {
      location.href = "/mynavi/realinfo/center/content/write";
    },
    //청소년기관스페셜 콘텐츠 수정페이지
    onClickYouthOrganizationUpdate: function (uidKey) {
      location.href = "/mynavi/realinfo/center/content/update?uidKey=" + uidKey;
    },
    //청소년기관스페셜 콘텐츠 목록
    onClickCenterContentList: function () {
      let vm = this;
      location.href = "/customer/realinfo?tabIdx=1";
    },

    //청소년기관스페셜 콘텐츠 등록
    fnSetCenterContent: function () {
      let vm = this;
      let _fileKey = $('#fileKey').val();
      if (vm.videoRes.resValue != null && vm.videoRes.resValue !== "succ") {
        alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        return false;
      }

      //유효성 체크
      let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
      let _IsContent = validation.isEmpty(vm.mynaviModel.content);
      //let _IsLink = Validator.methods.fnValidateHmpg(vm.mynaviModel.link);
      let _IsContentType = validation.isEmpty(vm.mynaviModel.type);
      let _IsImg = (vm.$refs.img.cnt <= 0) ? true : false;
      let _IsVod = vm.mynaviModel.type == 'VOD' && vm.mynaviModel.fileVdList.length == 0;

      /*if (!_IsLink) {
        if (vm.mynaviModel.link === 'http://'
          || vm.mynaviModel.link === 'https://'
          || vm.mynaviModel.link === '') {

          vm.mynaviModel.link = '';
          _IsLink = true;
        }
      }*/

      let _param = {
        title: vm.mynaviModel.title,
        content: vm.mynaviModel.content,
        subGroup: 'BRDNVYTHNV03000',
        fileKey: _fileKey,
        link: vm.mynaviModel.link,
        contentType: vm.mynaviModel.type
      };
      let param = {param: _param};


      console.log(_IsTitle + " " + _IsContent + " " + _IsImg + " " + _IsVod);

      if (_IsTitle || _IsContent || _IsImg) {

        let _word = '';
        if (_IsTitle) {
          _word = '제목을 입력해주세요.';
        } else if (_IsContent) {
          _word = '내용을 입력해주세요.';
        } else if (_IsContentType) {
          _word = '방식을 선택해주세요.';
        } /*else if(_IsVod) {
          _word = 'VOD 방식 선택 시 영상을 등록해주세요.';
        }*/ else if (_IsImg) {
          _word = '이미지를 한 장 이상 등록해주세요.';
        }

        swal({
          text: _word,
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
            cancel: {
              text: "취소",
              value: false,
              visible: false,
            }
          },
          dangerMode: false,
        }).then(function(){
          if (_IsTitle){
            $('#title').focus();
          } else if(_IsContent){
            $("html, body").animate({scrollTop: $("#contentArea").offset().top-200}, 100);
          } else if(_IsContentType){
            $('#type').focus();
          }
        });
      }
      /*else if (_IsLink) {
        swal({
          text: '관련링크에 입력된 주소를 확인해주세요.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            cancel: {
              text: "취소",
              value: false,
              visible: false,
            },
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            }
          },
          dangerMode: false,
        }).then(function(){
          $('#link').focus();
        });
      } */
      else if (vm.mynaviModel.title.length > 200) {
          swal({
            text: '제목은 200자 이하로 입력해주세요.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
             cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
          }).then(function(){
            $('#title').focus();
          });
        }
        else {

        Axios.post("/api/realinfo/mynavi/organization/content/write", param).then(function (response) {
          let resultCnt = response.data.result;
          if (resultCnt > 0) {
            vm.fnCallImgAltSave();
            swal({
              title: '등록 완료',
              text: '게시물 등록이 완료되었습니다.',
              // icon: vm.fnOnLoadSwalImageData('success'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            }).then(result => {
              vm.onClickCenterContentList();
            });
          } else if (resultCnt == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else if (resultCnt == -1000){
            swal({
              text : "로그인이 필요한 기능입니다.\n다시 로그인하시겠습니까?",
              closeOnClickOutside : false,
              buttons : {
                confirm : {
                  text : "확인",
                  value : true,
                  visible : true
                },
                cancel : {
                  text : "취소",
                  value : false,
                  visible : true
                }
              }
            }).then(result => {
              if(result){
                location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
              }
            });
            return false;

          } else {
            swal({
              title: '등록 실패',
              text: '게시물 등록이 실패하였습니다.',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false,
            });
          }
        }).catch(function (ex) {
          swal({
            title: '등록 실패',
            text: '게시물 등록이 실패하였습니다.',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false,
          });
        });
      }
    },
    //청소년기관스페셜 콘텐츠 수정
    fnChgCenterContent: function (_type) {
      let vm = this;
      if (vm.videoRes.resValue != null && vm.videoRes.resValue !== "succ") {
        alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        return false;
      }
      let _uidKey = $('#uidKey').val();
      let _fileKey = $('#fileKey').val();

      //유효성 체크
      let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
      let _IsContent = validation.isEmpty(vm.mynaviModel.content);
      if (vm.mynaviModel.link == null) vm.mynaviModel.link = '';
      let _IsLink = Validator.methods.fnValidateHmpg(vm.mynaviModel.link);
      let _IsContentType = validation.isEmpty(vm.mynaviModel.type);
      let _IsImg = (vm.$refs.img.cnt <= 0) ? true : false;

      if (!_IsLink) {
        if (vm.mynaviModel.link === 'http://'
          || vm.mynaviModel.link === 'https://'
          || vm.mynaviModel.link === '') {

          vm.mynaviModel.link = '';
          _IsLink = true;
        }
      }

      let _param = {
        title: vm.mynaviModel.title,
        content: vm.mynaviModel.content,
        uidKey: _uidKey,
        contentType: vm.mynaviModel.type,
        link: vm.mynaviModel.link,
        fileKey: _fileKey
      };
      let param = {param: _param};

      console.log(_IsTitle + " " + _IsContent + " " + _IsImg);


      if (_IsTitle || _IsContent || _IsImg) {

        let _word = '';
        if (_IsTitle) {
          _word = '제목을 입력해주세요.';
        } else if (_IsContent) {
          _word = '내용을 입력해주세요.';
        } else if (_IsContentType) {
          _word = '방식을 입력해주세요.';
        } else if (_IsImg) {
          _word = '이미지를 한 장 이상 등록해주세요.';
        }

        swal({
          text: _word,
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
            cancel: {
              text: "취소",
              value: false,
              visible: false,
            }
          },
          dangerMode: false,
        });
      } else if (!_IsLink) {
        swal({
          text: '관련링크에 입력된 주소를 확인해주세요.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            cancel: {
              text: "확인",
              value: false,
              visible: false,
            },
            confirm: {
              text: "취소",
              value: true,
              visible: true,
            }
          },
          dangerMode: false,
        });
      } else {
        if (vm.mynaviModel.title.length > 200) {
          swal({
            text: '제목은 200자 이하로 입력해주세요.',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "확인",
                value: false,
                visible: false,
              },
              confirm: {
                text: "취소",
                value: true,
                visible: true,
              }
            },
            dangerMode: false,
          });
        } else {
          Axios.post("/api/realinfo/mynavi/organization/content/update", param).then(function (response) {
            let resultCnt = response.data.result;
            let word = '';
            if (_type === 'update') {
              word = '수정'
            } else if (_type === 'delete') {
              word = '삭제'
            }
            if (resultCnt > 0) {
              if (_type === 'update') vm.fnCallImgAltSave();
              swal({
                title: word + ' 완료',
                text: '게시물 ' + word + '이 완료되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  }
                },
                dangerMode: false
              }).then(result => {
                vm.onClickCenterContentList();
              });
            } else if (result == -999) {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else if(resultCnt == -1000){
              swal({
                text : "로그인이 필요한 기능입니다.\n다시 로그인하시겠습니까?",
                closeOnClickOutside : false,
                buttons : {
                  confirm : {
                    text : "확인",
                    value : true,
                    visible : true
                  },
                  cancel : {
                    text : "취소",
                    value : false,
                    visible : true
                  }
                }
              }).then(result => {
                if(result){
                  location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
                }
              });
              return false;
            } else {
              let word = '';
              if (_type === 'update') {
                word = '수정'
              } else if (_type === 'delete') {
                word = '삭제'
              }
              swal({
                title: word + ' 실패',
                text: '게시물 ' + word + '이 실패되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  }
                },
                dangerMode: false,
              });
            }
          }).catch(function (ex) {
            let word = '';
            if (_type === 'update') {
              word = '수정'
            } else if (_type === 'delete') {
              word = '삭제'
            }
            swal({
              title: word + ' 실패',
              text: '게시물 ' + word + '이 실패하였습니다.',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false,
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false,
            });
          });
        }
      }
    },
    //마이네비 청소년기관스페셜 콘텐츠 수정 페이지
    fnGetCenterContent: function (_uidKey) {
      let vm = this;
      if (_uidKey != null || _uidKey != undefined || _uidKey != '') {
        _uidKey = $('#uidKey').val();
      }

      let _param = {
        uidKey: _uidKey,
        tab: '1'
      };
      let param = {param: _param};
      Axios.post("/api/realinfo/mynavi/organization/content/select", param).then(function (response) {

        let tmp = response.data.paramBrdDto;
        vm.mynaviModel.title = tmp.title;
        vm.mynaviModel.link = tmp.link;
        vm.mynaviModel.insertDate = new Date(tmp.insertDate);
        vm.mynaviModel.content = tmp.contentFirst;
        vm.mynaviModel.type = tmp.type;
        vm.postingModel.code = tmp.subCategory;
        if (vm.postingModel.categoryList.length > 0) {
          vm.postingModel.categoryList.forEach(function (object) {
            if (object.code == tmp.subCategory) {
              vm.selectSubCatBoxInContentList = object;
            }
          });
        }
        vm.mynaviModel.fileImgList = response.data.fileImgList;
        vm.mynaviModel.fileVdList = response.data.fileVdList;

        if (vm.mynaviModel.fileImgList.length > 0) {
          vm.mynaviModel.fileImgList.forEach(function (file) {
            file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
          });
        }
        if (vm.mynaviModel.fileVdList.length > 0) {
          vm.mynaviModel.fileVdList.forEach(function (file) {
            file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        return false;
      });
    },
    //게시물 삭제
    onClickBoardDetailDelete: function (_uidKey) {
      let vm = this;
      let _param = {uidKey: _uidKey};
      let param = {param: _param};
      Axios.post("/api/realinfo/board/delete", param).then(function (response) {
        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          swal({
            title: '삭제 완료',
            text: '게시물 삭제가 완료되었습니다.',
            // icon: vm.fnOnLoadSwalImageData('success'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
             cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
            dangerMode: false
          }).then(result => {
            let _pageName = $('#pageName').val();
            if (_pageName === 'facilityDetail') {
              vm.onClickCenterContentList();
            } else if (_pageName === 'contentDetail') {
              vm.onClickContentList();
            }
          });
        } else {
          swal({
            title: '삭제 실패',
            text: '게시물 삭제가 실패되었습니다.',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
             cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
            dangerMode: false,
          });
        }
      }).catch(function (ex) {
        swal({
          title: '삭제 실패',
          text: '게시물 삭제가 실패하였습니다.',
          // icon: vm.fnOnLoadSwalImageData('error'),
          buttons: {
            cancel: {
              text: "취소",
              value: false,
              visible: false,
            },
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
          dangerMode: false,
        });
      });
    },
    fnOnClickDetailPage: function (_url, name, param) {
      let url = _url + '?uidKey=' + param.uidKey + "&tab=" + $("#tab").val();
      window.open(url, name, "width=800, height=700, toolbar=no, menubar=no, scrollbars=no, resizable=yes");
    },
    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    },
    fnOnLoadKakaoContent: function (value) {
      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      if (_atag == null) {
        return '';
      }
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      if (_nbsptag == null) {
        return '';
      }
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");
      if (_httptag == null) {
        return '';
      }

      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;
    },
    //카카오 공유
    fnOnClickKakaoShare: function () {
      let vm = this;
      let tmpObj = {};
      let _pageName = $('#pageName').val();
      let _imgPath = '';
      let _content = ''
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName === 'contentDetail') {
          tmpObj = vm.mentoGroupModel.contentVO;
          _uri = urlAddress + '/customer/realinfo/content/detail?uidKey=' + tmpObj.uidKey + "&shared=Y";
          vm.fnShareLog(tmpObj.uidKey);
        } else if (_pageName === 'facilityDetail') {
          tmpObj = vm.mainViewModel.youthFacltVO;
          _uri = urlAddress + '/customer/realinfo/facility/detail?uidKey=' + tmpObj.uidKey + "&shared=Y";
          vm.fnShareLog(tmpObj.uidKey);
        } else if (_pageName === 'eventDetail') {
          tmpObj = vm.mentoGroupModel.eventVO;
          _uri = urlAddress + '/customer/realinfo/eventAnnounce?uidKey=' + tmpObj.uidKey + "&shared=Y";
          vm.fnShareLog(tmpObj.uidKey);
        }

        if (tmpObj.fileImgList != null && tmpObj.fileImgList.length > 0) {
          _imgPath = urlAddress + '/' + tmpObj.fileImgList[0].fileUrl;
        }

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          tmpObj.title,
          _imgPath,
          '',
          '',
          '',
          '',
          ''
        );
      });
    },
    //네이버공유
    fnOnClickNaverShare: function () {
      let vm = this;
      let _pageName = $('#pageName').val();
      let _uidKey = $('#uidKey').val();
      let _tmpObj = {};
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName === 'contentDetail') {
          _tmpObj = vm.mentoGroupModel.contentVO;
          _uri = urlAddress + '/customer/realinfo/content/detail?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'facilityDetail') {
          _tmpObj = vm.mainViewModel.youthFacltVO;
          _uri = urlAddress + '/customer/realinfo/facility/detail?uidKey=' + _uidKey + "&shared=Y";

          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'eventDetail') {
          _tmpObj = vm.mentoGroupModel.eventVO;
          _uri = urlAddress + '/customer/realinfo/eventAnnounce?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          _tmpObj.title
        );
      });
    },
    //페이스공유
    fnOnClickFacebookShare: function () {
      let vm = this;
      let _pageName = $('#pageName').val();
      let _uidKey = $('#uidKey').val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName === 'contentDetail') {
          _uri = urlAddress + '/customer/realinfo/content/detail?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'facilityDetail') {
          _uri = urlAddress + '/customer/realinfo/facility/detail?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'eventDetail') {
          _uri = urlAddress + '/customer/realinfo/eventAnnounce?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        }

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    },
    //링크공유
    fnOnClickLinkShare: function () {
      let vm = this;
      let tmpObj = {};
      let _pageName = $('#pageName').val();
      let _uidKey = $('#uidKey').val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName === 'contentDetail') {
          _uri = urlAddress + '/customer/realinfo/content/detail?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'facilityDetail') {
          _uri = urlAddress + '/customer/realinfo/facility/detail?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        } else if (_pageName === 'eventDetail') {
          _uri = urlAddress + '/customer/realinfo/eventAnnounce?uidKey=' + _uidKey + "&shared=Y";
          vm.fnShareLog(_uidKey);
        }

        let popup_url = '/customer/activity/share/link?url=' + encodeURIComponent(_uri);
        window.open(popup_url, '공유하기', 'width=550, heigth=550, toolbar=no, menubar=no, scrollbars=no, resizable=no');
      });
    },
    fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    fnSwalSuccess(_text, successFunction) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon: this.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancle: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            setTimeout(function () {
              successFunction();
            }, 2000);
          }
        }
      });
    },
    onClickEventReplyWrite() {
      let vm = this;
      vm.isReplyOn = true;
      vm.replyModel.userKey = $("#loginUserKey").val();
      this.mentoGroupModel.userKey = $("#loginUserKey").val();
      // if (vm.replyModel.userKey == null || vm.replyModel.userKey === '') {
      //   swal("로그인한 유저만 가능힙니다.");
      //   return
      // }

      vm.replyModel.replyName = vm.commonParams.loginUserNickName;
      vm.replyModel.replyContents = '';
    },
    onClickEventReviewReplyCancle() {
      let vm = this;
      vm.isReplyOn = false;
      vm.isReReplyOn = false;
      vm.replyModel.replyContents = '';
      vm.fnGetBoardDetail();
    },
    onClickEventReplySubmit() {
      let vm = this;
      let param = {
        buid: vm.mentoGroupModel.eventVO.uidKey,
        starCnt: vm.replyModel.replyStarCnt,
        userKey: vm.replyModel.userKey,
        content: vm.replyModel.replyContents
      };
      if (vm.validationReply()) {
        Axios.post("/api/pare/contents/reply/write", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickEventReviewReplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    fnGetBoardDetail() {
      let vm = this;
      let param = {
        uidKey: vm.mentoGroupModel.eventVO.uidKey,
        userKey: $("#loginUserKey").val()
      };
      Axios.post("/api/pare/board/detail", param).then(function (response) {
        vm.replyModel.userKey = $("#loginUserKey").val();
        vm.replyModel.replyList = (response.data.pareBcomList == null) ? [] : response.data.pareBcomList;
        vm.replyModel.rereplyList = (response.data.pareReBcomList == null) ? [] : response.data.pareReBcomList;


      }).catch(function (ex) {
        console.log(ex);
      });
    },
    onClickEventReplyModity: function (item) {
      let vm = this;
      vm.replyModel.modifyTarget = item.replyUid;
      vm.replyModel.modifyContents = item.content;
      vm.fpt = ''

    },
    onClickPareReviewRemodirfyCancle: function () {
      let vm = this;
      vm.replyModel.modifyContents = '';
      vm.replyModel.modifyTarget = '';
      vm.fnGetBoardDetail();
    },
    onClickEventRemodirfySubmit: function (reply_uid) {
      let vm = this;
      let param = {};

      param = {
        buid: vm.mentoGroupModel.eventVO.uidKey,
        uidKey: reply_uid,
        userKey: vm.replyModel.userKey,
        content: vm.replyModel.modifyContents,
        starCnt: 0
      };


      Axios.post("/api/pare/contents/reply/modify", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess('정상적으로 수정되었습니다.', vm.onClickPareReviewRemodirfyCancle());
        } else if (result == -999) {
          swal({
            title: '수정 실패',
            text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('댓글수정에 실패하였습니다.');
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert('댓글수정에 실패하였습니다.');
        return false;
      });
    },
    OnClickPareReviewReplyDelete: function (reply_uid) {
      let vm = this;

      let param = {
        buid: vm.mentoGroupModel.eventVO.uidKey,
        uidKey: reply_uid
      };

      swal({
        text: "해당 댓글을 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/contents/reply/delete", param).then(function (response) {
            let result = response.data.result;
            if (result == 1) {

              vm.fnSwalSuccess('삭제되었습니다.', vm.fnGetBoardDetail());

            } else {
              vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
            return false;
          });
        } else {
          return false;
        }
      });

    },
    onClickEventRemodirfyCancle: function () {
      let vm = this;
      vm.replyModel.modifyContents = '';
      vm.replyModel.modifyTarget = '';

      vm.fnGetBoardDetail();
    },
    // 이벤트 대댓글
    onClickEventReReplyOn: function (uidKey) {
      let vm = this;
      vm.replyModel.reReplyTarget = uidKey;
      vm.replyModel.replyName = vm.commonParams.loginUserNickName;
    },
    //대댓글영역 취소
    onClickEventRereplyCancle: function () {
      let vm = this;
      vm.replyModel.reReplyContents = '';
      vm.replyModel.reReplyTarget = '';
      vm.fnGetBoardDetail();
    },
    //대댓글 작성
    onClickPareReviewRereplySubmit: function () {
      let vm = this;
      let param = {};

      let _parentUid = vm.replyModel.reReplyTarget;
      let _uid = vm.mentoGroupModel.eventVO.uidKey;
      param = {
        buid: _uid,
        userKey: vm.replyModel.userKey,
        content: vm.replyModel.reReplyContents,
        depth: 1,
        parentUid: _parentUid
      };

      if (vm.validationRereply()) {
        Axios.post("/api/pare/contents/reReply/write", param).then(function (response) {
          let result = response.data.result;
          if (result > 0) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickEventRereplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    validationReply() {
      let vm = this;
      let userKey = $("#loginUserKey").val();
      let replyName = vm.replyModel.replyName == "" ? false : true;
      let content = vm.replyModel.replyContents.trim() == "" ? false : true;

      /*   if(userKey == null || userKey == ""){
                if(!replyName){
                    vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
                    return false;
                }else if(!replyPassword){
                    vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
                    return false;
                }
            } */

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }

      if (userKey == null || userKey == "") {
        if (replyName && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    onStoryEditorChange(e) {
      this.selectDetailInf.evt31 = e.html;
    },
    validationRereply() {
      let vm = this;
      let userKey = $("#loginUserKey").val();
      let content = vm.replyModel.reReplyContents == "" ? false : true;


      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }

      if (userKey == null || userKey == "") {
        if (content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    eventPreAlert(_name) {
      let vm = this;
      let name = _name + "이벤트가 진행예정입니다.";
      vm.fnSwalAlert(name);
    },
    fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon: this.fnOnLoadSwalImageData("warning"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancle: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    },
    fnDeclareEnter: function (value) {
      let vm = this;

      if (vm.mentoGroupModel.reportValues.indexOf(value) > -1) {
        vm.mentoGroupModel.reportValues = "";
      } else {
        vm.mentoGroupModel.reportValues = value;
      }
    },


    /* ----------- 진로 동기멘토 ----------- */
    // 코드 목록(계열) 가져오기
    fnOnPostCode(code) {
      let vm = this;
      let param = {
        searchCode: code
      };
      Axios.post("/api/expinfo/lineCodeList", param).then(function (response) {
        vm.expInfoCodeList = response.data.expinfoCodeList;
        vm.lineCode2List = response.data.lineCode2List;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOutGunLabel(val) {
      if (val === '') return '선택'
      if (val === '1') return '대학생'
      if (val === '2') return '교수'
      if (val === '3') return '전문가'
    },
    fnExpMentoLineCodeValueCheck() { // 진로동기멘토 프로필 입력 체크
      let vm = this

      // 기존에 프로필 이미지가 없었음
      const emptyOldProfile = vm.expMentoModel.userImage == null || vm.expMentoModel.userImage === ''

      // 현재 폼에 프로필 이미지 업로드를 했는지 여부
      const uploadedNewProfile = vm.mynaviViewModel.isProfileUpdate && vm.$refs.profile.cnt > 0;

      // 수정모드 + 기존에 프로필이 없었음 + 지금도 업로드 안함
      if (vm.expMentoModel.uidKey > 0 && emptyOldProfile && !uploadedNewProfile) {
        return "프로필 이미지를 등록해 주세요."
      }

      // 신규모드 + 업로드 안함 + 기존(승인 받았었던) 프로필에도 사진이 없었음
      if (vm.expMentoModel.uidKey < 1 && !uploadedNewProfile && emptyOldProfile) return "프로필 이미지를 등록해 주세요."

      if (vm.expMentoModel.nickName === "") return "멘토명을 입력해 주세요."
      if (vm.expMentoModel.gubun === "") return "구분을 선택해 주세요."
      if (vm.expMentoModel.lineValues.length < 1) return "계열을 선택해 주세요." // 계열 상위 코드를 하나도 선택안한 경우

      // // 계열 하위 코드가 있는데 체크를 안한 경우
      // for (let key in vm.expMentoLineMap) {
      //   const chkCnt = vm.expMentoLineMap[key].length; // 체크한 하위코드 건수
      //   const childCnt = vm.lineCode2List[key].length; // 하위코드 건수
      //
      //   if (childCnt > 0 && chkCnt < 1) { // 하위 코드가 있는데 체크를 안한 경우
      //     const mcode = vm.expInfoCodeList.find(mcItem => mcItem.cmm_sys_cd === key) // 해당 상위코드명을 찾는다
      //     if (mcode !== undefined) {
      //       return "'" + mcode.cmm_sys_titl + "'의 상세 계열을 선택해 주세요."
      //     }
      //     return "상세 계열을 선택해 주세요."
      //   }
      //
      // }
      return ""
    },
    //진로동기멘토 프로필 수정 (reqType = temp/req)
    onClickExpMentoProfileUpdate(reqType) {
      let vm = this;

      const chkMsg = vm.fnExpMentoLineCodeValueCheck(); // 입력값 체크
      if (chkMsg !== "") return alert(chkMsg);

      let _param = {
        cmm_uid: vm.expMentoModel.uidKey,   // key (수정 시에는 있고, 신규는 0)
        cmm_nck_nm: vm.expMentoModel.nickName, // 멘토명
        cmm_gubun: vm.expMentoModel.gubun,     // 구분
        lineList: vm.expMentoModel.lineValues,// 계열
        lineDetailList: vm.expMentoModel.lineDetailValues,// 계열 상세
        cmm_info: vm.expMentoModel.info,        // 소속
        cmm_career: vm.expMentoModel.career,      // 경력
        cmm_intr: vm.expMentoModel.intr,        // 소개글
        cmm_req_status: reqType,                    // temp(임시저장) 또는 req(저장)
        fileKey: $('#fileKey').val(),
        lineCodeJson: JSON.stringify(vm.expMentoLineMap),
        prevOkUidkey: vm.expMentoModel.prev_ok_uidkey
      };
      let param = {expMentoDto: _param};
      console.log("param : ", param);

      Axios.post("/api/expinfo/mynavi/mentoinfo/update", param).then(function (response) {
        console.log("res")
        let resultCnt = response.data.result;
        if (resultCnt > 0) {
          swal({
            title: reqType === 'temp' ? '임시저장 완료' : '저장 완료',
            text: reqType === 'temp' ? '프로필 정보를 임시저장 하였습니다.' : '프로필을 정상적으로 저장하였습니다.',
            // icon: vm.fnOnLoadSwalImageData('success'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
             cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
            dangerMode: false
          }).then(result => {
            location.href = "/mynavi/user/common";
          });
        } else {
          swal({
            title: reqType === 'temp' ? '임시저장 실패' : '저장 실패',
            text: reqType === 'temp' ? '프로필 임시저장을 실패하였습니다.' : '프로필 저장을 실패하였습니다.',
            // icon: this.fnOnLoadSwalImageData('error'),
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
             cancel: {
                text: "취소",
                value: false,
                visible: false,
              }
            },
            dangerMode: false,
          });
        }
      }).catch(function (ex) {
        console.log(ex);
        swal({
          title: reqType === 'temp' ? '임시저장 실패' : '저장 실패',
          text: reqType === 'temp' ? '프로필 임시저장을 실패하였습니다.' : '프로필 저장을 실패하였습니다.',
          // icon: this.fnOnLoadSwalImageData('error'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
            cancel: {
              text: "취소",
              value: false,
              visible: false,
            }

          },
          dangerMode: false,
        });
      });

    },
    fnGetExpMentoProfile() { // 나의 내비쌤 프로필 조회
      let vm = this;
      Axios.post("/api/expinfo/mynavi/mentoinfo/detail", {}).then(function (response) {
        var ddd = response.data.expMentoVo;
        var ldList = response.data.expMentoLineDetailList;
        if (ddd == null) return;

        vm.expMentoModel.nickName = ddd.cmm_nck_nm
        vm.expMentoModel.gubun = ddd.cmm_gubun
        vm.expMentoModel.lineValues = (ddd.lineList == null || ddd.lineList == undefined || ddd.lineList == "") ? [] : ddd.lineList.split(",");
        vm.expMentoModel.lineDetailValues = (ddd.lineDetailList == null || ddd.lineDetailList == undefined || ddd.lineDetailList == "") ? [] : ddd.lineDetailList.split(",");
        vm.expMentoModel.info = ddd.cmm_info
        vm.expMentoModel.career = ddd.cmm_career
        vm.expMentoModel.intr = ddd.cmm_intr
        vm.expMentoModel.userImage = ddd.userImage
        vm.expMentoModel.reqStatus = ddd.cmm_req_status
        vm.expMentoModel.viewYn = ddd.cmm_view_yn

        if (ddd.cmm_status !== "확인") { // ok가 아닌 경우만, uidKey 셋팅 (즉, 수정모드)
          vm.expMentoModel.uidKey = ddd.cmm_uid
        } else {
          vm.expMentoModel.prev_ok_uidkey = ddd.cmm_uid
        }

        // 계열 체크박스용 변수 셋팅
        if (ldList == null || ldList.length < 1) return;
        ldList.forEach(ldItem => {
          vm.expMentoLineMap[ldItem.lineList] = (ldItem.lineDetailList == null || ldItem.lineDetailList == undefined || ldItem.lineDetailList == "") ? [] : ldItem.lineDetailList.split(",");
        })

      })

    },
    fnOnClickExpMentoLineCheckBox(value) { // 진로체험활동 멘토의 계열 체크박스 클릭

      let vm = this
      if(vm.expMentoModel.lineValues.includes(value)) {
        vm.expMentoModel.lineValues = jQuery.grep(vm.expMentoModel.lineValues, function(val) {
          return val != value;
        });
      } else {
        vm.expMentoModel.lineValues.push(value);
      }
      console.log(vm.expMentoModel.lineValues);
      if (vm.expMentoLineMap.hasOwnProperty(value)) {
        const dlist = vm.expMentoLineMap[value]
        const ldvList = vm.expMentoModel.lineDetailValues

        // 1. value 의 상세 코드들을 lineDetailValues 에서 제거
        vm.expMentoModel.lineDetailValues = ldvList.filter(linecode => {
          var isSame = false;
          for (var i = 0; i < dlist.length; i++) {
            if (dlist[i] === linecode) {
              isSame = true;
              break;
            }
          }
          return !isSame
        })

        // 2. expMentoLineMap 에서도 제거
        delete vm.expMentoLineMap[value]
      } else {
        vm.expMentoLineMap[value] = []
      }
    },
    fnOnClickExpMentoLineDetailCheckBox(pcode, value, checked) { // 진로체험활동 멘토의 계열 상세 체크박스 클릭
      let vm = this
      if (!vm.expMentoLineMap.hasOwnProperty(pcode)) return; // 부모가 무조건 필요하므로.. 없는 경우는 일단 패스

      if (checked) { // 체크한 경우
        vm.expMentoLineMap[pcode].push(value) // 추가
      } else {
        const dlist = vm.expMentoLineMap[pcode]
        vm.expMentoLineMap[pcode] = dlist.filter(v => v !== value) // vm.expMentoLineMap[pcode] 에서 삭제
      }
    },
    fnCallImgAltSave: function () { // 이미지 alt 저장
      this.$refs.img.fnParentSaveCB()
    },
    fnGetEventResult() { // 투표 이벤트 정보 조회
      let vm = this;
      let param = {uidKey: vm.mentoGroupModel.eventVO.uidKey};

      Axios.post("/api/realinfo/eventResult/select", param).then(function (response) {
        vm.eventVoteItemList = response.data.evtVoteItemList;
        vm.eventVoteResultList = response.data.evtVoteResultList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    /* ============================= 목록 상태 저장/복구 (contentList) ============================= */
    saveContentListState() {
      const _path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
      if (_path !== '/customer/realinfo/content/list') return;
      try {
        const state = {
          ts: Date.now(),
          orderingCodeValue: this.postingModel.orderingCodeValue,
          code: this.postingModel.code,
          codeName: this.postingModel.codeName,
          keyword: this.postingModel.keyword,
          isLatest: this.postingModel.isLatest,
          isPopularity: this.postingModel.isPopularity,
          pageNo: this.viewModel.pager.pageNo,
          list: this.mentoGroupModel.mentoContentsList,
          showMore: this.viewModel.showMore,
          scrollY: window.scrollY
        };
        sessionStorage.setItem(CONTENT_LIST_STATE_KEY, JSON.stringify(state));
      } catch(e){
        console.log('[CONTENT_LIST] save state error', e);
      }
    },
    restoreContentListState() {
      const _path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
      if (_path !== '/customer/realinfo/content/list') return false;
      const raw = sessionStorage.getItem(CONTENT_LIST_STATE_KEY);
      if(!raw) return false;
      try {
        const st = JSON.parse(raw);
        // TTL 15분
        if(Date.now() - st.ts > 15 * 60 * 1000) {
          sessionStorage.removeItem(CONTENT_LIST_STATE_KEY);
          return false;
        }
        this.postingModel.orderingCodeValue = st.orderingCodeValue;
        this.postingModel.code = st.code;
        this.postingModel.codeName = st.codeName;
        this.postingModel.keyword = st.keyword;
        this.postingModel.isLatest = st.isLatest;
        this.postingModel.isPopularity = st.isPopularity;
        this.viewModel.pager.pageNo = st.pageNo;
        this.mentoGroupModel.mentoContentsList = st.list || [];
        this.viewModel.showMore = st.showMore;
        // DOM 렌더 후 스크롤 위치 복구
        this.$nextTick(()=> {
          window.scrollTo(0, st.scrollY || 0);
        });
        return true;
      } catch(e){
        console.log('[CONTENT_LIST] restore state error', e);
        return false;
      }
    }
    /*============================================================ 목록 상태 저장/복구 end ========================================================================*/
  },


});
